var _defs, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _path85, _path86, _path87, _path88, _path89, _path90, _path91, _path92, _path93, _path94, _path95, _path96, _path97, _path98, _path99, _path100, _path101, _path102, _path103, _path104, _path105, _path106, _path107, _path108, _path109, _path110, _path111, _path112, _path113, _path114, _path115, _path116, _path117, _path118, _path119, _path120, _path121, _path122, _path123, _path124, _path125, _path126, _path127, _path128, _path129, _path130, _path131, _path132, _path133, _path134, _path135, _path136, _path137, _path138, _path139, _path140, _path141, _path142, _path143, _path144, _path145, _path146, _path147, _path148, _path149, _path150, _path151, _path152, _path153, _path154, _path155, _path156, _path157, _path158, _path159, _path160, _path161, _path162, _path163, _path164, _path165, _path166, _path167, _path168, _path169, _path170, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAmiriyaHero(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 2143 737",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1,.cls-10,.cls-100,.cls-101,.cls-102,.cls-103,.cls-104,.cls-105,.cls-106,.cls-107,.cls-108,.cls-109,.cls-11,.cls-110,.cls-111,.cls-112,.cls-113,.cls-114,.cls-115,.cls-116,.cls-117,.cls-118,.cls-119,.cls-12,.cls-120,.cls-121,.cls-122,.cls-123,.cls-124,.cls-125,.cls-126,.cls-127,.cls-128,.cls-129,.cls-13,.cls-130,.cls-131,.cls-132,.cls-133,.cls-134,.cls-135,.cls-136,.cls-137,.cls-138,.cls-139,.cls-14,.cls-140,.cls-141,.cls-142,.cls-143,.cls-144,.cls-145,.cls-146,.cls-147,.cls-148,.cls-149,.cls-15,.cls-150,.cls-151,.cls-152,.cls-153,.cls-154,.cls-155,.cls-156,.cls-157,.cls-158,.cls-159,.cls-16,.cls-160,.cls-161,.cls-162,.cls-163,.cls-164,.cls-165,.cls-166,.cls-167,.cls-168,.cls-169,.cls-17,.cls-170,.cls-18,.cls-19,.cls-2,.cls-20,.cls-21,.cls-22,.cls-23,.cls-24,.cls-25,.cls-26,.cls-27,.cls-28,.cls-29,.cls-3,.cls-30,.cls-31,.cls-32,.cls-33,.cls-34,.cls-35,.cls-36,.cls-37,.cls-38,.cls-39,.cls-4,.cls-40,.cls-41,.cls-42,.cls-43,.cls-44,.cls-45,.cls-46,.cls-47,.cls-48,.cls-49,.cls-5,.cls-50,.cls-51,.cls-52,.cls-53,.cls-54,.cls-55,.cls-56,.cls-57,.cls-58,.cls-59,.cls-6,.cls-60,.cls-61,.cls-62,.cls-63,.cls-64,.cls-65,.cls-66,.cls-67,.cls-68,.cls-69,.cls-7,.cls-70,.cls-71,.cls-72,.cls-73,.cls-74,.cls-75,.cls-76,.cls-77,.cls-78,.cls-79,.cls-8,.cls-80,.cls-81,.cls-82,.cls-83,.cls-84,.cls-85,.cls-86,.cls-87,.cls-88,.cls-89,.cls-9,.cls-90,.cls-91,.cls-92,.cls-93,.cls-94,.cls-95,.cls-96,.cls-97,.cls-98,.cls-99{fill:none;}.cls-1,.cls-10,.cls-105,.cls-106,.cls-107,.cls-108,.cls-109,.cls-11,.cls-110,.cls-111,.cls-112,.cls-113,.cls-114,.cls-115,.cls-116,.cls-117,.cls-118,.cls-119,.cls-12,.cls-120,.cls-121,.cls-122,.cls-123,.cls-124,.cls-125,.cls-126,.cls-127,.cls-128,.cls-129,.cls-13,.cls-130,.cls-131,.cls-132,.cls-133,.cls-134,.cls-135,.cls-136,.cls-137,.cls-138,.cls-139,.cls-14,.cls-140,.cls-141,.cls-142,.cls-143,.cls-144,.cls-145,.cls-146,.cls-147,.cls-148,.cls-149,.cls-15,.cls-150,.cls-151,.cls-152,.cls-153,.cls-154,.cls-155,.cls-156,.cls-157,.cls-158,.cls-159,.cls-16,.cls-160,.cls-161,.cls-162,.cls-163,.cls-164,.cls-165,.cls-166,.cls-167,.cls-168,.cls-169,.cls-17,.cls-170,.cls-18,.cls-19,.cls-2,.cls-20,.cls-21,.cls-22,.cls-23,.cls-24,.cls-25,.cls-26,.cls-27,.cls-3,.cls-4,.cls-5,.cls-6,.cls-7,.cls-8,.cls-9{stroke-width:1.5px;}.cls-1{stroke:url(#linear-gradient);}.cls-2{stroke:url(#linear-gradient-2);}.cls-3{stroke:url(#linear-gradient-3);}.cls-4{stroke:url(#linear-gradient-4);}.cls-5{stroke:url(#linear-gradient-5);}.cls-6{stroke:url(#linear-gradient-6);}.cls-7{stroke:url(#linear-gradient-7);}.cls-8{stroke:url(#linear-gradient-8);}.cls-9{stroke:url(#linear-gradient-9);}.cls-10{stroke:url(#linear-gradient-10);}.cls-11{stroke:url(#linear-gradient-11);}.cls-12{stroke:url(#linear-gradient-12);}.cls-13{stroke:url(#linear-gradient-13);}.cls-14{stroke:url(#linear-gradient-14);}.cls-15{stroke:url(#linear-gradient-15);}.cls-16{stroke:url(#linear-gradient-16);}.cls-17{stroke:url(#linear-gradient-17);}.cls-18{stroke:url(#linear-gradient-18);}.cls-19{stroke:url(#linear-gradient-19);}.cls-20{stroke:url(#linear-gradient-20);}.cls-21{stroke:url(#linear-gradient-21);}.cls-22{stroke:url(#linear-gradient-22);}.cls-23{stroke:url(#linear-gradient-23);}.cls-24{stroke:url(#linear-gradient-24);}.cls-25{stroke:url(#linear-gradient-25);}.cls-26{stroke:url(#linear-gradient-26);}.cls-27{stroke:url(#linear-gradient-27);}.cls-100,.cls-101,.cls-102,.cls-103,.cls-104,.cls-28,.cls-29,.cls-30,.cls-31,.cls-32,.cls-33,.cls-34,.cls-35,.cls-36,.cls-37,.cls-38,.cls-39,.cls-40,.cls-41,.cls-42,.cls-43,.cls-44,.cls-45,.cls-46,.cls-47,.cls-48,.cls-49,.cls-50,.cls-51,.cls-52,.cls-53,.cls-54,.cls-55,.cls-56,.cls-57,.cls-58,.cls-59,.cls-60,.cls-61,.cls-62,.cls-63,.cls-64,.cls-65,.cls-66,.cls-67,.cls-68,.cls-69,.cls-70,.cls-71,.cls-72,.cls-73,.cls-74,.cls-75,.cls-76,.cls-77,.cls-78,.cls-79,.cls-80,.cls-81,.cls-82,.cls-83,.cls-84,.cls-85,.cls-86,.cls-87,.cls-88,.cls-89,.cls-90,.cls-91,.cls-92,.cls-93,.cls-94,.cls-95,.cls-96,.cls-97,.cls-98,.cls-99{stroke-miterlimit:10;}.cls-28{stroke:url(#linear-gradient-28);}.cls-29{stroke:url(#linear-gradient-29);}.cls-30{stroke:url(#linear-gradient-30);}.cls-31{stroke:url(#linear-gradient-31);}.cls-32{stroke:url(#linear-gradient-32);}.cls-33{stroke:url(#linear-gradient-33);}.cls-34{stroke:url(#linear-gradient-34);}.cls-35{stroke:url(#linear-gradient-35);}.cls-36{stroke:url(#linear-gradient-36);}.cls-37{stroke:url(#linear-gradient-37);}.cls-38{stroke:url(#linear-gradient-38);}.cls-39{stroke:url(#linear-gradient-39);}.cls-40{stroke:url(#linear-gradient-40);}.cls-41{stroke:url(#linear-gradient-41);}.cls-42{stroke:url(#linear-gradient-42);}.cls-43{stroke:url(#linear-gradient-43);}.cls-44{stroke:url(#linear-gradient-44);}.cls-45{stroke:url(#linear-gradient-45);}.cls-46{stroke:url(#linear-gradient-46);}.cls-47{stroke:url(#linear-gradient-47);}.cls-48{stroke:url(#linear-gradient-48);}.cls-49{stroke:url(#linear-gradient-49);}.cls-50{stroke:url(#linear-gradient-50);}.cls-51{stroke:url(#linear-gradient-51);}.cls-52{stroke:url(#linear-gradient-52);}.cls-53{stroke:url(#linear-gradient-53);}.cls-54{stroke:url(#linear-gradient-54);}.cls-55{stroke:url(#linear-gradient-55);}.cls-56{stroke:url(#linear-gradient-56);}.cls-57{stroke:url(#linear-gradient-57);}.cls-58{stroke:url(#linear-gradient-58);}.cls-59{stroke:url(#linear-gradient-59);}.cls-60{stroke:url(#linear-gradient-60);}.cls-61{stroke:url(#linear-gradient-61);}.cls-62{stroke:url(#linear-gradient-62);}.cls-63{stroke:url(#linear-gradient-63);}.cls-64{stroke:url(#linear-gradient-64);}.cls-65{stroke:url(#linear-gradient-65);}.cls-66{stroke:url(#linear-gradient-66);}.cls-67{stroke:url(#linear-gradient-67);}.cls-68{stroke:url(#linear-gradient-68);}.cls-69{stroke:url(#linear-gradient-69);}.cls-70{stroke:url(#linear-gradient-70);}.cls-71{stroke:url(#linear-gradient-71);}.cls-72{stroke:url(#linear-gradient-72);}.cls-73{stroke:url(#linear-gradient-73);}.cls-74{stroke:url(#linear-gradient-74);}.cls-75{stroke:url(#linear-gradient-75);}.cls-76{stroke:url(#linear-gradient-76);}.cls-77{stroke:url(#linear-gradient-77);}.cls-78{stroke:url(#linear-gradient-78);}.cls-79{stroke:url(#linear-gradient-79);}.cls-80{stroke:url(#linear-gradient-80);}.cls-81{stroke:url(#linear-gradient-81);}.cls-82{stroke:url(#linear-gradient-82);}.cls-83{stroke:url(#linear-gradient-83);}.cls-84{stroke:url(#linear-gradient-84);}.cls-85{stroke:url(#linear-gradient-85);}.cls-86{stroke:url(#linear-gradient-86);}.cls-87{stroke:url(#linear-gradient-87);}.cls-88{stroke:url(#linear-gradient-88);}.cls-89{stroke:url(#linear-gradient-89);}.cls-90{stroke:url(#linear-gradient-90);}.cls-91{stroke:url(#linear-gradient-91);}.cls-92{stroke:url(#linear-gradient-92);}.cls-93{stroke:url(#linear-gradient-93);}.cls-94{stroke:url(#linear-gradient-94);}.cls-95{stroke:url(#linear-gradient-95);}.cls-96{stroke:url(#linear-gradient-96);}.cls-97{stroke:url(#linear-gradient-97);}.cls-98{stroke:url(#linear-gradient-98);}.cls-99{stroke:url(#linear-gradient-99);}.cls-100{stroke:url(#linear-gradient-100);}.cls-101{stroke:url(#linear-gradient-101);}.cls-102{stroke:url(#linear-gradient-102);}.cls-103{stroke:url(#linear-gradient-103);}.cls-104{stroke:url(#linear-gradient-104);}.cls-105{stroke:url(#linear-gradient-105);}.cls-106{stroke:url(#linear-gradient-106);}.cls-107{stroke:url(#linear-gradient-107);}.cls-108{stroke:url(#linear-gradient-108);}.cls-109{stroke:url(#linear-gradient-109);}.cls-110{stroke:url(#linear-gradient-110);}.cls-111{stroke:url(#linear-gradient-111);}.cls-112{stroke:url(#linear-gradient-112);}.cls-113{stroke:url(#linear-gradient-113);}.cls-114{stroke:url(#linear-gradient-114);}.cls-115{stroke:url(#linear-gradient-115);}.cls-116{stroke:url(#linear-gradient-116);}.cls-117{stroke:url(#linear-gradient-117);}.cls-118{stroke:url(#linear-gradient-118);}.cls-119{stroke:url(#linear-gradient-119);}.cls-120{stroke:url(#linear-gradient-120);}.cls-121{stroke:url(#linear-gradient-121);}.cls-122{stroke:url(#linear-gradient-122);}.cls-123{stroke:url(#linear-gradient-123);}.cls-124{stroke:url(#linear-gradient-124);}.cls-125{stroke:url(#linear-gradient-125);}.cls-126{stroke:url(#linear-gradient-126);}.cls-127{stroke:url(#linear-gradient-127);}.cls-128{stroke:url(#linear-gradient-128);}.cls-129{stroke:url(#linear-gradient-129);}.cls-130{stroke:url(#linear-gradient-130);}.cls-131{stroke:url(#linear-gradient-131);}.cls-132{stroke:url(#linear-gradient-132);}.cls-133{stroke:url(#linear-gradient-133);}.cls-134{stroke:url(#linear-gradient-134);}.cls-135{stroke:url(#linear-gradient-135);}.cls-136{stroke:url(#linear-gradient-136);}.cls-137{stroke:url(#linear-gradient-137);}.cls-138{stroke:url(#linear-gradient-138);}.cls-139{stroke:url(#linear-gradient-139);}.cls-140{stroke:url(#linear-gradient-140);}.cls-141{stroke:url(#linear-gradient-141);}.cls-142{stroke:url(#linear-gradient-142);}.cls-143{stroke:url(#linear-gradient-143);}.cls-144{stroke:url(#linear-gradient-144);}.cls-145{stroke:url(#linear-gradient-145);}.cls-146{stroke:url(#linear-gradient-146);}.cls-147{stroke:url(#linear-gradient-147);}.cls-148{stroke:url(#linear-gradient-148);}.cls-149{stroke:url(#linear-gradient-149);}.cls-150{stroke:url(#linear-gradient-150);}.cls-151{stroke:url(#linear-gradient-151);}.cls-152{stroke:url(#linear-gradient-152);}.cls-153{stroke:url(#linear-gradient-153);}.cls-154{stroke:url(#linear-gradient-154);}.cls-155{stroke:url(#linear-gradient-155);}.cls-156{stroke:url(#linear-gradient-156);}.cls-157{stroke:url(#linear-gradient-157);}.cls-158{stroke:url(#linear-gradient-158);}.cls-159{stroke:url(#linear-gradient-159);}.cls-160{stroke:url(#linear-gradient-160);}.cls-161{stroke:url(#linear-gradient-161);}.cls-162{stroke:url(#linear-gradient-162);}.cls-163{stroke:url(#linear-gradient-163);}.cls-164{stroke:url(#linear-gradient-164);}.cls-165{stroke:url(#linear-gradient-165);}.cls-166{stroke:url(#linear-gradient-166);}.cls-167{stroke:url(#linear-gradient-167);}.cls-168{stroke:url(#linear-gradient-168);}.cls-169{stroke:url(#linear-gradient-169);}.cls-170{stroke:url(#linear-gradient-170);}.cls-171{opacity:0.32;}.cls-172{opacity:0.24;isolation:isolate;fill:url(#linear-gradient-171);}"), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 1970.41,
    y1: -80.4,
    x2: 1973.25,
    y2: -82.72,
    gradientTransform: "translate(-339949.29 15138.77) scale(173.13 177.07)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff",
    stopOpacity: 0.64
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: 1970.35,
    y1: -80.47,
    x2: 1973.19,
    y2: -82.79,
    gradientTransform: "translate(-338632.98 14917.13) scale(172.47 174.24)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-3",
    x1: 1970.29,
    y1: -80.53,
    x2: 1973.13,
    y2: -82.85,
    gradientTransform: "translate(-337414.46 14712.16) scale(171.86 171.66)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-4",
    x1: 1970.26,
    y1: -80.59,
    x2: 1973.1,
    y2: -82.9,
    gradientTransform: "translate(-336303.88 14451.26) scale(171.3 168.38)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-5",
    x1: 1970.07,
    y1: -80.83,
    x2: 1972.91,
    y2: -83.15,
    gradientTransform: "translate(-335204.23 14206.76) scale(170.75 165.34)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-6",
    x1: 1970.18,
    y1: -80.71,
    x2: 1973.02,
    y2: -83.02,
    gradientTransform: "translate(-333935.77 13955.74) scale(170.11 162.16)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-7",
    x1: 1970.14,
    y1: -80.77,
    x2: 1972.99,
    y2: -83.08,
    gradientTransform: "translate(-332741.97 13690.59) scale(169.51 158.86)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-8",
    x1: 1970.11,
    y1: -80.84,
    x2: 1972.96,
    y2: -83.15,
    gradientTransform: "translate(-331590.74 13404.95) scale(168.93 155.27)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-9",
    x1: 1969.88,
    y1: -81.17,
    x2: 1972.72,
    y2: -83.48,
    gradientTransform: "translate(-330526.31 13125.89) scale(168.4 151.71)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-10",
    x1: 1970.02,
    y1: -81.03,
    x2: 1972.86,
    y2: -83.34,
    gradientTransform: "translate(-329515.9 12835.37) scale(167.89 148.05)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-11",
    x1: 1969.98,
    y1: -81.13,
    x2: 1972.83,
    y2: -83.44,
    gradientTransform: "translate(-328594.69 12533.55) scale(167.43 144.29)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-12",
    x1: 1969.94,
    y1: -81.21,
    x2: 1972.78,
    y2: -83.53,
    gradientTransform: "translate(-327206.56 12229.63) scale(166.73 140.44)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-13",
    x1: 1969.91,
    y1: -81.32,
    x2: 1972.76,
    y2: -83.63,
    gradientTransform: "translate(-326169.57 11915.39) scale(166.21 136.52)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-14",
    x1: 1969.88,
    y1: -81.44,
    x2: 1972.72,
    y2: -83.75,
    gradientTransform: "translate(-325198.48 11600.86) scale(165.72 132.52)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-15",
    x1: 1969.84,
    y1: -81.56,
    x2: 1972.69,
    y2: -83.88,
    gradientTransform: "translate(-324355.65 11277.1) scale(165.3 128.47)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-16",
    x1: 1969.81,
    y1: -81.7,
    x2: 1972.66,
    y2: -84.02,
    gradientTransform: "translate(-323676.04 10952.27) scale(164.96 124.38)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-17",
    x1: 1969.81,
    y1: -81.84,
    x2: 1972.65,
    y2: -84.15,
    gradientTransform: "translate(-323161.21 10623.33) scale(164.7 120.24)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-18",
    x1: 1969.82,
    y1: -81.97,
    x2: 1972.66,
    y2: -84.29,
    gradientTransform: "translate(-322825.24 10292.53) scale(164.53 116.07)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-19",
    x1: 1969.78,
    y1: -82.18,
    x2: 1972.62,
    y2: -84.5,
    gradientTransform: "translate(-322675.52 9963.68) scale(164.46 111.88)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-20",
    x1: 1969.8,
    y1: -82.34,
    x2: 1972.65,
    y2: -84.65,
    gradientTransform: "translate(-322699.76 9629.04) scale(164.47 107.69)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-21",
    x1: 1969.81,
    y1: -82.53,
    x2: 1972.65,
    y2: -84.84,
    gradientTransform: "translate(-322914.81 9297.26) scale(164.58 103.5)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-22",
    x1: 1969.69,
    y1: -82.92,
    x2: 1972.54,
    y2: -85.23,
    gradientTransform: "translate(-323308.96 8965.63) scale(164.78 99.32)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-23",
    x1: 1969.85,
    y1: -82.99,
    x2: 1972.69,
    y2: -85.3,
    gradientTransform: "translate(-323912.24 8634.43) scale(165.09 95.17)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-24",
    x1: 1969.88,
    y1: -83.24,
    x2: 1972.72,
    y2: -85.55,
    gradientTransform: "translate(-324684.71 8307.88) scale(165.48 91.04)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-25",
    x1: 1969.79,
    y1: -83.67,
    x2: 1972.63,
    y2: -85.98,
    gradientTransform: "translate(-325658.28 7983.55) scale(165.97 86.95)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-26",
    x1: 1969.84,
    y1: -83.96,
    x2: 1972.68,
    y2: -86.28,
    gradientTransform: "translate(-326804.63 7662.73) scale(166.55 82.92)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-27",
    x1: 1970.04,
    y1: -84.09,
    x2: 1972.88,
    y2: -86.4,
    gradientTransform: "translate(-328076.24 7345.88) scale(167.19 78.91)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-28",
    x1: 1415.26,
    y1: 321.05,
    x2: 2097.09,
    y2: 321.05,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#153d5e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.38,
    stopColor: "#0b2a49"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.68,
    stopColor: "#a7861f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-29",
    x1: 1417.39,
    y1: 321.16,
    x2: 2095.03,
    y2: 321.16,
    xlinkHref: "#linear-gradient-28"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-30",
    x1: 1419.53,
    y1: 320.91,
    x2: 2092.97,
    y2: 320.91,
    xlinkHref: "#linear-gradient-28"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-31",
    x1: 1421.66,
    y1: 320.66,
    x2: 2090.92,
    y2: 320.66,
    xlinkHref: "#linear-gradient-28"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-32",
    x1: 1423.79,
    y1: 320.56,
    x2: 2088.77,
    y2: 320.56,
    xlinkHref: "#linear-gradient-28"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-33",
    x1: 1425.93,
    y1: 320.61,
    x2: 2086.76,
    y2: 320.61,
    xlinkHref: "#linear-gradient-28"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-34",
    x1: 1427.36,
    y1: 320.05,
    x2: 2084.69,
    y2: 320.05,
    xlinkHref: "#linear-gradient-28"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-35",
    x1: 1430.31,
    y1: 320.08,
    x2: 2082.54,
    y2: 320.08,
    xlinkHref: "#linear-gradient-28"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-36",
    x1: 1432.45,
    y1: 319.81,
    x2: 2080.46,
    y2: 319.81,
    xlinkHref: "#linear-gradient-28"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-37",
    x1: 1434.6,
    y1: 319.69,
    x2: 2078.35,
    y2: 319.69,
    xlinkHref: "#linear-gradient-28"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-38",
    x1: 1436.74,
    y1: 319.74,
    x2: 2076.28,
    y2: 319.74,
    xlinkHref: "#linear-gradient-28"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-39",
    x1: 1438.88,
    y1: 319.44,
    x2: 2074.2,
    y2: 319.44,
    xlinkHref: "#linear-gradient-28"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-40",
    x1: 1441.03,
    y1: 319.28,
    x2: 2072.25,
    y2: 319.28,
    xlinkHref: "#linear-gradient-28"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-41",
    x1: 1443.16,
    y1: 319.16,
    x2: 2070.02,
    y2: 319.16,
    xlinkHref: "#linear-gradient-28"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-42",
    x1: 1445.01,
    y1: 319.05,
    x2: 2067.92,
    y2: 319.05,
    xlinkHref: "#linear-gradient-28"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-43",
    x1: 1447.45,
    y1: 318.94,
    x2: 2066.15,
    y2: 318.94,
    xlinkHref: "#linear-gradient-28"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-44",
    x1: 1449.59,
    y1: 318.82,
    x2: 2064.08,
    y2: 318.82,
    xlinkHref: "#linear-gradient-28"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-45",
    x1: 1451.74,
    y1: 318.67,
    x2: 2061.94,
    y2: 318.67,
    xlinkHref: "#linear-gradient-28"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-46",
    x1: 1453.87,
    y1: 318.55,
    x2: 2059.83,
    y2: 318.55,
    xlinkHref: "#linear-gradient-28"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-47",
    x1: 1456.01,
    y1: 318.42,
    x2: 2057.8,
    y2: 318.42,
    xlinkHref: "#linear-gradient-28"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-48",
    x1: 1457.87,
    y1: 318.58,
    x2: 2055.78,
    y2: 318.58,
    xlinkHref: "#linear-gradient-28"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-49",
    x1: 1457.3,
    y1: 318.97,
    x2: 2053.74,
    y2: 318.97,
    xlinkHref: "#linear-gradient-28"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-50",
    x1: 1462.08,
    y1: 318.27,
    x2: 2051.59,
    y2: 318.27,
    xlinkHref: "#linear-gradient-28"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-51",
    x1: 1464.28,
    y1: 318.14,
    x2: 2049.53,
    y2: 318.14,
    xlinkHref: "#linear-gradient-28"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-52",
    x1: 1466.41,
    y1: 318,
    x2: 2047.47,
    y2: 318,
    xlinkHref: "#linear-gradient-28"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-53",
    x1: 1468.52,
    y1: 317.95,
    x2: 2045.44,
    y2: 317.95,
    xlinkHref: "#linear-gradient-28"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-54",
    x1: 1470.68,
    y1: 319.17,
    x2: 2043.34,
    y2: 319.17,
    xlinkHref: "#linear-gradient-28"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-55",
    x1: 1472.79,
    y1: 319.27,
    x2: 2041.27,
    y2: 319.27,
    xlinkHref: "#linear-gradient-28"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-56",
    x1: 1474.88,
    y1: 319.91,
    x2: 2039.14,
    y2: 319.91,
    xlinkHref: "#linear-gradient-28"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-57",
    x1: 1477.06,
    y1: 320.56,
    x2: 2037.14,
    y2: 320.56,
    xlinkHref: "#linear-gradient-28"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-58",
    x1: 1479.22,
    y1: 321.98,
    x2: 2035.08,
    y2: 321.98,
    xlinkHref: "#linear-gradient-28"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-59",
    x1: 1481.37,
    y1: 322.19,
    x2: 2033.02,
    y2: 322.19,
    xlinkHref: "#linear-gradient-28"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-60",
    x1: 1483.48,
    y1: 322.53,
    x2: 2030.94,
    y2: 322.53,
    xlinkHref: "#linear-gradient-28"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-61",
    x1: 1485.56,
    y1: 323.18,
    x2: 2028.84,
    y2: 323.18,
    xlinkHref: "#linear-gradient-28"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-62",
    x1: 1487.63,
    y1: 323.83,
    x2: 2026.89,
    y2: 323.83,
    xlinkHref: "#linear-gradient-28"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-63",
    x1: 1489.85,
    y1: 324.45,
    x2: 2024.76,
    y2: 324.45,
    xlinkHref: "#linear-gradient-28"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-64",
    x1: 1491.97,
    y1: 325.16,
    x2: 2022.7,
    y2: 325.16,
    xlinkHref: "#linear-gradient-28"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-65",
    x1: 1494.1,
    y1: 325.81,
    x2: 2020.55,
    y2: 325.81,
    xlinkHref: "#linear-gradient-28"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-66",
    x1: 1496.17,
    y1: 326.46,
    x2: 2018.54,
    y2: 326.46,
    xlinkHref: "#linear-gradient-28"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-67",
    x1: 1498.4,
    y1: 327.11,
    x2: 2016.53,
    y2: 327.11,
    xlinkHref: "#linear-gradient-28"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-68",
    x1: 1500.49,
    y1: 327.97,
    x2: 2014.4,
    y2: 327.97,
    xlinkHref: "#linear-gradient-28"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-69",
    x1: 1502.61,
    y1: 328.45,
    x2: 2012.42,
    y2: 328.45,
    xlinkHref: "#linear-gradient-28"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-70",
    x1: 1504.78,
    y1: 329.09,
    x2: 2010.34,
    y2: 329.09,
    xlinkHref: "#linear-gradient-28"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-71",
    x1: 1506.93,
    y1: 329.75,
    x2: 2008.21,
    y2: 329.75,
    xlinkHref: "#linear-gradient-28"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-72",
    x1: 1508.99,
    y1: 331.25,
    x2: 2006.2,
    y2: 331.25,
    xlinkHref: "#linear-gradient-28"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-73",
    x1: 1511.15,
    y1: 331.06,
    x2: 2004.15,
    y2: 331.06,
    xlinkHref: "#linear-gradient-28"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-74",
    x1: 1513.22,
    y1: 331.75,
    x2: 2002.04,
    y2: 331.75,
    xlinkHref: "#linear-gradient-28"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-75",
    x1: 1515.39,
    y1: 332.35,
    x2: 2000.02,
    y2: 332.35,
    xlinkHref: "#linear-gradient-28"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-76",
    x1: 1517.48,
    y1: 333.82,
    x2: 1997.93,
    y2: 333.82,
    xlinkHref: "#linear-gradient-28"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-77",
    x1: 1519.59,
    y1: 333.68,
    x2: 1995.91,
    y2: 333.68,
    xlinkHref: "#linear-gradient-28"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-78",
    x1: 1521.74,
    y1: 335.15,
    x2: 1993.81,
    y2: 335.15,
    xlinkHref: "#linear-gradient-28"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-79",
    x1: 1523.84,
    y1: 335.81,
    x2: 1991.76,
    y2: 335.81,
    xlinkHref: "#linear-gradient-28"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-80",
    x1: 1525.95,
    y1: 335.72,
    x2: 1989.67,
    y2: 335.72,
    xlinkHref: "#linear-gradient-28"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-81",
    x1: 1528.1,
    y1: 336.4,
    x2: 1987.61,
    y2: 336.4,
    xlinkHref: "#linear-gradient-28"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-82",
    x1: 1530.22,
    y1: 337.02,
    x2: 1985.56,
    y2: 337.02,
    xlinkHref: "#linear-gradient-28"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-83",
    x1: 1532.36,
    y1: 337.64,
    x2: 1983.52,
    y2: 337.64,
    xlinkHref: "#linear-gradient-28"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-84",
    x1: 1534.48,
    y1: 338.59,
    x2: 1981.49,
    y2: 338.59,
    xlinkHref: "#linear-gradient-28"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-85",
    x1: 1536.59,
    y1: 339.15,
    x2: 1979.39,
    y2: 339.15,
    xlinkHref: "#linear-gradient-28"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-86",
    x1: 1537.7,
    y1: 340.46,
    x2: 1977.33,
    y2: 340.46,
    xlinkHref: "#linear-gradient-28"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-87",
    x1: 1540.84,
    y1: 340.27,
    x2: 1975.2,
    y2: 340.27,
    xlinkHref: "#linear-gradient-28"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-88",
    x1: 1542.01,
    y1: 341.22,
    x2: 1973.16,
    y2: 341.22,
    xlinkHref: "#linear-gradient-28"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-89",
    x1: 1545.04,
    y1: 341.69,
    x2: 1971.12,
    y2: 341.69,
    xlinkHref: "#linear-gradient-28"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-90",
    x1: 1547.2,
    y1: 342.36,
    x2: 1969.08,
    y2: 342.36,
    xlinkHref: "#linear-gradient-28"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-91",
    x1: 1548.65,
    y1: 342.91,
    x2: 1967.03,
    y2: 342.91,
    xlinkHref: "#linear-gradient-28"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-92",
    x1: 1551.37,
    y1: 343.57,
    x2: 1964.95,
    y2: 343.57,
    xlinkHref: "#linear-gradient-28"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-93",
    x1: 1553.52,
    y1: 344.15,
    x2: 1962.85,
    y2: 344.15,
    xlinkHref: "#linear-gradient-28"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-94",
    x1: 1555.61,
    y1: 344.82,
    x2: 1960.76,
    y2: 344.82,
    xlinkHref: "#linear-gradient-28"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-95",
    x1: 1557.76,
    y1: 345.72,
    x2: 1958.76,
    y2: 345.72,
    xlinkHref: "#linear-gradient-28"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-96",
    x1: 1559.9,
    y1: 346.34,
    x2: 1956.78,
    y2: 346.34,
    xlinkHref: "#linear-gradient-28"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-97",
    x1: 1561.92,
    y1: 346.98,
    x2: 1954.62,
    y2: 346.98,
    xlinkHref: "#linear-gradient-28"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-98",
    x1: 1564.09,
    y1: 347.53,
    x2: 1952.68,
    y2: 347.53,
    xlinkHref: "#linear-gradient-28"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-99",
    x1: 1566.18,
    y1: 348.35,
    x2: 1950.57,
    y2: 348.35,
    xlinkHref: "#linear-gradient-28"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-100",
    x1: 1568.3,
    y1: 349.35,
    x2: 1948.55,
    y2: 349.35,
    xlinkHref: "#linear-gradient-28"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-101",
    x1: 1570.39,
    y1: 349.71,
    x2: 1946.4,
    y2: 349.71,
    xlinkHref: "#linear-gradient-28"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-102",
    x1: 1572.5,
    y1: 350.44,
    x2: 1944.44,
    y2: 350.44,
    xlinkHref: "#linear-gradient-28"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-103",
    x1: 1574.58,
    y1: 351.14,
    x2: 1942.39,
    y2: 351.14,
    xlinkHref: "#linear-gradient-28"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-104",
    x1: 1578,
    y1: 351.59,
    x2: 1939,
    y2: 351.59,
    xlinkHref: "#linear-gradient-28"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-105",
    x1: 1964.81,
    y1: -82.03,
    x2: 1966.49,
    y2: -83.25,
    gradientTransform: "translate(-213894.44 12130.62) scale(109.47 142.58)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff",
    stopOpacity: 0.16
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-106",
    x1: 1964.57,
    y1: -82.4,
    x2: 1966.25,
    y2: -83.61,
    gradientTransform: "translate(-213947.34 12042.26) scale(109.5 141.42)",
    xlinkHref: "#linear-gradient-105"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-107",
    x1: 1964.76,
    y1: -82.17,
    x2: 1966.45,
    y2: -83.39,
    gradientTransform: "translate(-214142.42 11950.71) scale(109.6 140.29)",
    xlinkHref: "#linear-gradient-105"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-108",
    x1: 1964.85,
    y1: -82.13,
    x2: 1966.54,
    y2: -83.35,
    gradientTransform: "translate(-214484.92 11862.04) scale(109.77 139.16)",
    xlinkHref: "#linear-gradient-105"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-109",
    x1: 1964.85,
    y1: -82.2,
    x2: 1966.54,
    y2: -83.41,
    gradientTransform: "translate(-214775.59 11775.18) scale(109.92 138.05)",
    xlinkHref: "#linear-gradient-105"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-110",
    x1: 1964.9,
    y1: -82.22,
    x2: 1966.59,
    y2: -83.44,
    gradientTransform: "translate(-215372.17 11695.7) scale(110.22 137)",
    xlinkHref: "#linear-gradient-105"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-111",
    x1: 1964.94,
    y1: -82.27,
    x2: 1966.62,
    y2: -83.49,
    gradientTransform: "translate(-216103.62 11637.23) scale(110.59 136.24)",
    xlinkHref: "#linear-gradient-105"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-112",
    x1: 1965.02,
    y1: -82.29,
    x2: 1966.7,
    y2: -83.5,
    gradientTransform: "translate(-216973.57 11574.86) scale(111.03 135.45)",
    xlinkHref: "#linear-gradient-105"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-113",
    x1: 1965.11,
    y1: -82.28,
    x2: 1966.8,
    y2: -83.5,
    gradientTransform: "translate(-217949.95 11509.35) scale(111.52 134.62)",
    xlinkHref: "#linear-gradient-105"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-114",
    x1: 1965.2,
    y1: -82.31,
    x2: 1966.89,
    y2: -83.53,
    gradientTransform: "translate(-219058.09 11439.04) scale(112.08 133.74)",
    xlinkHref: "#linear-gradient-105"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-115",
    x1: 1965.28,
    y1: -82.37,
    x2: 1966.96,
    y2: -83.58,
    gradientTransform: "translate(-220284.47 11367.27) scale(112.7 132.8)",
    xlinkHref: "#linear-gradient-105"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-116",
    x1: 1965.39,
    y1: -82.39,
    x2: 1967.07,
    y2: -83.61,
    gradientTransform: "translate(-221630.77 11287.03) scale(113.38 131.81)",
    xlinkHref: "#linear-gradient-105"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-117",
    x1: 1965.47,
    y1: -82.47,
    x2: 1967.15,
    y2: -83.68,
    gradientTransform: "translate(-223078.27 11219.28) scale(114.11 130.9)",
    xlinkHref: "#linear-gradient-105"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-118",
    x1: 1965.61,
    y1: -82.46,
    x2: 1967.3,
    y2: -83.68,
    gradientTransform: "translate(-224644.67 11122.7) scale(114.9 129.71)",
    xlinkHref: "#linear-gradient-105"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-119",
    x1: 1965.74,
    y1: -82.5,
    x2: 1967.42,
    y2: -83.72,
    gradientTransform: "translate(-226308.65 11024.65) scale(115.74 128.47)",
    xlinkHref: "#linear-gradient-105"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-120",
    x1: 1965.86,
    y1: -82.56,
    x2: 1967.54,
    y2: -83.78,
    gradientTransform: "translate(-228071.81 10924.86) scale(116.63 127.18)",
    xlinkHref: "#linear-gradient-105"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-121",
    x1: 1965.95,
    y1: -82.63,
    x2: 1967.64,
    y2: -83.85,
    gradientTransform: "translate(-229675.02 10823.17) scale(117.44 125.86)",
    xlinkHref: "#linear-gradient-105"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-122",
    x1: 1966.14,
    y1: -82.63,
    x2: 1967.83,
    y2: -83.85,
    gradientTransform: "translate(-231706.07 10714.78) scale(118.46 124.53)",
    xlinkHref: "#linear-gradient-105"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-123",
    x1: 1966.28,
    y1: -82.68,
    x2: 1967.97,
    y2: -83.9,
    gradientTransform: "translate(-233827.46 10609.05) scale(119.53 123.18)",
    xlinkHref: "#linear-gradient-105"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-124",
    x1: 1966.41,
    y1: -82.77,
    x2: 1968.1,
    y2: -83.98,
    gradientTransform: "translate(-236044.73 10504.28) scale(120.65 121.81)",
    xlinkHref: "#linear-gradient-105"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-125",
    x1: 1966.57,
    y1: -82.8,
    x2: 1968.26,
    y2: -84.01,
    gradientTransform: "translate(-238325.38 10392.53) scale(121.8 120.44)",
    xlinkHref: "#linear-gradient-105"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-126",
    x1: 1966.74,
    y1: -82.85,
    x2: 1968.42,
    y2: -84.07,
    gradientTransform: "translate(-240669.05 10284.71) scale(122.98 119.03)",
    xlinkHref: "#linear-gradient-105"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-127",
    x1: 1966.87,
    y1: -82.95,
    x2: 1968.56,
    y2: -84.16,
    gradientTransform: "translate(-243100.68 10172.14) scale(124.21 117.6)",
    xlinkHref: "#linear-gradient-105"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-128",
    x1: 1967.02,
    y1: -83,
    x2: 1968.71,
    y2: -84.22,
    gradientTransform: "translate(-245578.68 10056.3) scale(125.46 116.13)",
    xlinkHref: "#linear-gradient-105"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-129",
    x1: 1967.2,
    y1: -83.05,
    x2: 1968.88,
    y2: -84.26,
    gradientTransform: "translate(-248117.92 9934.37) scale(126.74 114.62)",
    xlinkHref: "#linear-gradient-105"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-130",
    x1: 1967.34,
    y1: -83.12,
    x2: 1969.03,
    y2: -84.34,
    gradientTransform: "translate(-250701.16 9814.9) scale(128.04 113.05)",
    xlinkHref: "#linear-gradient-105"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-131",
    x1: 1967.52,
    y1: -83.17,
    x2: 1969.2,
    y2: -84.39,
    gradientTransform: "translate(-253341.33 9685.42) scale(129.37 111.43)",
    xlinkHref: "#linear-gradient-105"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-132",
    x1: 1967.55,
    y1: -83.43,
    x2: 1969.24,
    y2: -84.65,
    gradientTransform: "translate(-256032.31 9552.6) scale(130.73 109.73)",
    xlinkHref: "#linear-gradient-105"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-133",
    x1: 1967.83,
    y1: -83.32,
    x2: 1969.51,
    y2: -84.53,
    gradientTransform: "translate(-258754.59 9445.28) scale(132.1 108.37)",
    xlinkHref: "#linear-gradient-105"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-134",
    x1: 1967.97,
    y1: -83.4,
    x2: 1969.66,
    y2: -84.61,
    gradientTransform: "translate(-261527.38 9353.54) scale(133.5 107.2)",
    xlinkHref: "#linear-gradient-105"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-135",
    x1: 1968.15,
    y1: -83.42,
    x2: 1969.83,
    y2: -84.63,
    gradientTransform: "translate(-264327.55 9257.3) scale(134.91 106.02)",
    xlinkHref: "#linear-gradient-105"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-136",
    x1: 1968.28,
    y1: -83.5,
    x2: 1969.97,
    y2: -84.71,
    gradientTransform: "translate(-267178.53 9169.47) scale(136.35 104.89)",
    xlinkHref: "#linear-gradient-105"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-137",
    x1: 1968.45,
    y1: -83.53,
    x2: 1970.13,
    y2: -84.75,
    gradientTransform: "translate(-270052.46 9084.73) scale(137.8 103.85)",
    xlinkHref: "#linear-gradient-105"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-138",
    x1: 1968.4,
    y1: -83.85,
    x2: 1970.09,
    y2: -85.07,
    gradientTransform: "translate(-272949.29 9010.81) scale(139.26 102.91)",
    xlinkHref: "#linear-gradient-105"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-139",
    x1: 1968.74,
    y1: -83.64,
    x2: 1970.42,
    y2: -84.86,
    gradientTransform: "translate(-275882.56 8950.25) scale(140.74 102.09)",
    xlinkHref: "#linear-gradient-105"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-140",
    x1: 1968.9,
    y1: -83.65,
    x2: 1970.59,
    y2: -84.87,
    gradientTransform: "translate(-278841.87 8897.93) scale(142.23 101.44)",
    xlinkHref: "#linear-gradient-105"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-141",
    x1: 1969.04,
    y1: -83.68,
    x2: 1970.73,
    y2: -84.89,
    gradientTransform: "translate(-281833.14 8859.99) scale(143.74 100.97)",
    xlinkHref: "#linear-gradient-105"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-142",
    x1: 1969.22,
    y1: -83.66,
    x2: 1970.9,
    y2: -84.87,
    gradientTransform: "translate(-284835.66 8834.63) scale(145.25 100.66)",
    xlinkHref: "#linear-gradient-105"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-143",
    x1: 1969.33,
    y1: -83.7,
    x2: 1971.01,
    y2: -84.92,
    gradientTransform: "translate(-287882.13 8823.89) scale(146.79 100.5)",
    xlinkHref: "#linear-gradient-105"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-144",
    x1: 1969.49,
    y1: -83.67,
    x2: 1971.18,
    y2: -84.89,
    gradientTransform: "translate(-290925.01 8823.05) scale(148.32 100.48)",
    xlinkHref: "#linear-gradient-105"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-145",
    x1: 1969.64,
    y1: -83.65,
    x2: 1971.33,
    y2: -84.87,
    gradientTransform: "translate(-293995.88 8829.22) scale(149.87 100.6)",
    xlinkHref: "#linear-gradient-105"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-146",
    x1: 1969.78,
    y1: -83.63,
    x2: 1971.47,
    y2: -84.85,
    gradientTransform: "translate(-297092.19 8847.75) scale(151.43 100.82)",
    xlinkHref: "#linear-gradient-105"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-147",
    x1: 1969.91,
    y1: -83.62,
    x2: 1971.6,
    y2: -84.83,
    gradientTransform: "translate(-300200.67 8874.33) scale(153 101.17)",
    xlinkHref: "#linear-gradient-105"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-148",
    x1: 1970.05,
    y1: -83.59,
    x2: 1971.74,
    y2: -84.81,
    gradientTransform: "translate(-303314.69 8910.95) scale(154.57 101.63)",
    xlinkHref: "#linear-gradient-105"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-149",
    x1: 1970.21,
    y1: -83.53,
    x2: 1971.89,
    y2: -84.75,
    gradientTransform: "translate(-306435.49 8955.33) scale(156.14 102.19)",
    xlinkHref: "#linear-gradient-105"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-150",
    x1: 1970.32,
    y1: -83.51,
    x2: 1972.01,
    y2: -84.73,
    gradientTransform: "translate(-309566.7 9007.62) scale(157.72 102.83)",
    xlinkHref: "#linear-gradient-105"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-151",
    x1: 1970.46,
    y1: -83.45,
    x2: 1972.14,
    y2: -84.67,
    gradientTransform: "translate(-312702.42 9062.8) scale(159.3 103.54)",
    xlinkHref: "#linear-gradient-105"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-152",
    x1: 1970.57,
    y1: -83.43,
    x2: 1972.26,
    y2: -84.64,
    gradientTransform: "translate(-315657.1 9123.77) scale(160.79 104.29)",
    xlinkHref: "#linear-gradient-105"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-153",
    x1: 1970.68,
    y1: -83.39,
    x2: 1972.37,
    y2: -84.6,
    gradientTransform: "translate(-318707.67 9186.69) scale(162.33 105.09)",
    xlinkHref: "#linear-gradient-105"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-154",
    x1: 1970.77,
    y1: -83.38,
    x2: 1972.46,
    y2: -84.6,
    gradientTransform: "translate(-321742.82 9254.09) scale(163.86 105.95)",
    xlinkHref: "#linear-gradient-105"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-155",
    x1: 1970.93,
    y1: -83.28,
    x2: 1972.61,
    y2: -84.5,
    gradientTransform: "translate(-324772.17 9321.21) scale(165.39 106.83)",
    xlinkHref: "#linear-gradient-105"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-156",
    x1: 1971.05,
    y1: -83.22,
    x2: 1972.74,
    y2: -84.43,
    gradientTransform: "translate(-327775.62 9392.47) scale(166.9 107.74)",
    xlinkHref: "#linear-gradient-105"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-157",
    x1: 1971.09,
    y1: -83.29,
    x2: 1972.77,
    y2: -84.5,
    gradientTransform: "translate(-330801.13 9466.31) scale(168.43 108.64)",
    xlinkHref: "#linear-gradient-105"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-158",
    x1: 1971.21,
    y1: -83.22,
    x2: 1972.89,
    y2: -84.44,
    gradientTransform: "translate(-333803.54 9539.67) scale(169.94 109.55)",
    xlinkHref: "#linear-gradient-105"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-159",
    x1: 1971.36,
    y1: -83.1,
    x2: 1973.04,
    y2: -84.32,
    gradientTransform: "translate(-336813.21 9607.42) scale(171.46 110.45)",
    xlinkHref: "#linear-gradient-105"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-160",
    x1: 1971.47,
    y1: -83.07,
    x2: 1973.15,
    y2: -84.28,
    gradientTransform: "translate(-339789.66 9675.97) scale(172.96 111.32)",
    xlinkHref: "#linear-gradient-105"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-161",
    x1: 1971.5,
    y1: -83.13,
    x2: 1973.18,
    y2: -84.35,
    gradientTransform: "translate(-342800.25 9743.5) scale(174.48 112.14)",
    xlinkHref: "#linear-gradient-105"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-162",
    x1: 1971.66,
    y1: -83.01,
    x2: 1973.34,
    y2: -84.22,
    gradientTransform: "translate(-345801.31 9807.14) scale(175.99 112.94)",
    xlinkHref: "#linear-gradient-105"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-163",
    x1: 1971.76,
    y1: -82.96,
    x2: 1973.45,
    y2: -84.18,
    gradientTransform: "translate(-348829.85 9865.76) scale(177.52 113.72)",
    xlinkHref: "#linear-gradient-105"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-164",
    x1: 1971.85,
    y1: -82.94,
    x2: 1973.54,
    y2: -84.15,
    gradientTransform: "translate(-351884.43 9924.9) scale(179.06 114.47)",
    xlinkHref: "#linear-gradient-105"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-165",
    x1: 1971.94,
    y1: -82.91,
    x2: 1973.63,
    y2: -84.12,
    gradientTransform: "translate(-354624.46 9980.89) scale(180.44 115.16)",
    xlinkHref: "#linear-gradient-105"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-166",
    x1: 1972.05,
    y1: -82.84,
    x2: 1973.73,
    y2: -84.06,
    gradientTransform: "translate(-357697.56 10059.73) scale(181.99 116.19)",
    xlinkHref: "#linear-gradient-105"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-167",
    x1: 1972.08,
    y1: -82.92,
    x2: 1973.76,
    y2: -84.14,
    gradientTransform: "translate(-360909.51 10096.21) scale(183.61 116.65)",
    xlinkHref: "#linear-gradient-105"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-168",
    x1: 1972.14,
    y1: -82.94,
    x2: 1973.83,
    y2: -84.16,
    gradientTransform: "translate(-364158.81 10130.28) scale(185.25 117.07)",
    xlinkHref: "#linear-gradient-105"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-169",
    x1: 1972.32,
    y1: -82.83,
    x2: 1974.01,
    y2: -84.04,
    gradientTransform: "translate(-367570.81 10162.86) scale(186.97 117.45)",
    xlinkHref: "#linear-gradient-105"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-170",
    x1: 1972.42,
    y1: -83.07,
    x2: 1974.11,
    y2: -84.28,
    gradientTransform: "translate(-370729.75 9657.17) scale(188.56 111.08)",
    xlinkHref: "#linear-gradient-105"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-171",
    x1: 1979.78,
    y1: -81.57,
    x2: 1979.78,
    y2: -80.57,
    gradientTransform: "translate(-830545 27511) scale(420 340)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#3b82f6",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.71,
    stopColor: "#3b82f6",
    stopOpacity: 0.71
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#dbeafe"
  })))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "amiriyaHeroArtboard 1") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1643.22,445.4c6.24,2,13.08,5.88,20.22,11.32a187,187,0,0,1,21.91,20.39c7.27,7.75,14.33,16.05,20.61,23.81s11.78,14.95,16.11,21c10.46,14.63,14.09,22.13,8.67,26.68-3,2.52-7.81,4.7-14.27,7s-14.55,4.77-23.52,8.5a108.36,108.36,0,0,0-18,9.46,112.9,112.9,0,0,0-16.08,13c-6.49,6.23-12.42,13.16-18.63,19.24s-12.74,11.22-20.72,13.45c-6.18,1.73-12.71,2-19.77-3.56s-13.41-14.08-18.94-23.11a180.26,180.26,0,0,1-14.7-29.86c-3.61-9.53-5.78-18.2-6-26.56a73.34,73.34,0,0,1,6.26-31.07,138.44,138.44,0,0,1,18.83-31c8-10.19,17.53-19.77,27.25-25.54S1632.1,441.89,1643.22,445.4Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M1646.8,447.29c6.28,2.27,13.15,6.45,20.31,12.11a208,208,0,0,1,21.94,20.76c7.27,7.77,14.3,16,20.54,23.55s11.7,14.54,16,20.35c10.24,13.85,13.82,20.7,8.46,25-3,2.36-7.77,4.4-14.25,6.57s-14.66,4.44-23.78,7.89a111.51,111.51,0,0,0-18.49,8.9,106,106,0,0,0-16.46,12.44c-6.64,6-12.64,12.85-18.8,18.94s-12.54,11.37-20.22,13.88c-5.94,1.94-12.3,1-18.93-2.65s-13.21-12.49-18.69-21.32a166.63,166.63,0,0,1-14.57-29.86c-3.55-9.68-5.67-18.64-5.8-27.31a78.47,78.47,0,0,1,6.38-32.2A134.63,134.63,0,0,1,1589.2,473c8-10.11,17.35-19.38,26.86-24.56S1635.65,443.24,1646.8,447.29Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M1650.4,449.35c6.31,2.56,13.21,7,20.39,12.83a233.35,233.35,0,0,1,22,21C1700,491,1707,499,1713.23,506.44s11.61,14.08,15.86,19.61c10,13.07,13.58,19.31,8.29,23.31-3,2.23-7.71,4.16-14.21,6.19s-14.75,4.15-24,7.35a116.38,116.38,0,0,0-19,8.34,102,102,0,0,0-16.86,11.86c-6.8,5.84-12.89,12.51-19,18.58s-12.37,11.48-19.77,14.23c-5.73,2.14-11.81,1.5-18.14-1.79s-12.89-10.94-18.33-19.54a152.76,152.76,0,0,1-14.43-29.75c-3.5-9.81-5.57-19-5.66-28a83.62,83.62,0,0,1,6.49-33.3A132,132,0,0,1,1593.14,472c7.9-10,17.15-18.92,26.46-23.48S1639.21,444.81,1650.4,449.35Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M1654,451.57c6.32,2.75,13.3,7.46,20.48,13.47a260.79,260.79,0,0,1,22,21.22c7.25,7.7,14.22,15.63,20.39,22.81s11.54,13.59,15.74,18.84c9.85,12.28,13.38,17.93,8.17,21.71-2.9,2.1-7.62,3.94-14.14,5.86s-14.83,3.92-24.26,6.89a123.13,123.13,0,0,0-19.43,7.79,99.92,99.92,0,0,0-17.28,11.26c-7,5.63-13.18,12.15-19.31,18.19s-12.25,11.52-19.39,14.5c-5.53,2.31-11.35,2-17.4-1s-12.47-9.42-17.86-17.76a141.1,141.1,0,0,1-14.31-29.54c-3.46-9.93-5.47-19.4-5.52-28.64a88.08,88.08,0,0,1,2.92-23.3,104.92,104.92,0,0,1,8.69-21.93A133,133,0,0,1,1597,471.11c7.81-9.85,16.69-18.82,26.08-22S1643,446.75,1654,451.57Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M1657.63,454c6.33,2.94,13.3,7.85,20.55,14.05a302.79,302.79,0,0,1,22,21.29c7.23,7.63,14.17,15.39,20.31,22.33s11.46,13.06,15.63,18c9.67,11.49,13.17,16.47,8,20-2.91,2-7.46,4-13.91,5.86s-14.91,3.64-24.49,6.39a134.4,134.4,0,0,0-19.92,7.26,99.49,99.49,0,0,0-17.8,10.63c-7.17,5.41-13.5,11.75-19.64,17.74s-12.17,11.54-19.08,14.71c-5.35,2.46-10.92,2.41-16.71-.23s-12-8-17.3-16a129.2,129.2,0,0,1-14.18-29.25c-3.41-10-5.38-19.69-5.39-29.2a93.86,93.86,0,0,1,3-24,106.62,106.62,0,0,1,8.69-22.36,127.7,127.7,0,0,1,13.46-20.8c7.73-9.68,16.38-17.75,25.78-20.35s19.76-1.24,31,3.94Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M1661.26,456.49c6.37,3.14,13.36,8.23,20.61,14.52s14.76,13.74,22,21.27,14.13,15.09,20.23,21.78,11.39,12.49,15.53,17.15c9.5,10.69,12.73,14.79,7.71,18.43-2.81,2-7.24,4.1-13.6,6s-14.92,3.31-24.65,5.85a148,148,0,0,0-20.42,6.76,98.67,98.67,0,0,0-18.19,10.06c-7.37,5.16-13.84,11.32-20,17.23s-12.12,11.51-18.82,14.86a18.38,18.38,0,0,1-16.08.47c-5.54-2.33-11.33-6.62-16.64-14.34a117.54,117.54,0,0,1-14.07-28.84A93,93,0,0,1,1579.6,538a100.24,100.24,0,0,1,3.07-24.75,109.44,109.44,0,0,1,8.69-22.74,121.51,121.51,0,0,1,13.35-20.71c7.63-9.49,16.13-16.56,25.54-18.65S1650,451,1661.26,456.49Z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M1664.91,459.14c8.52,4.44,18.17,12.32,28,21.58s19.73,19.73,28.47,29,16.27,17.14,21.76,22.94c9.34,9.89,12.28,13.32,7.45,17.08-2.71,2.11-7,4.23-13.26,6.11s-14.87,2.9-24.75,5.25a164.45,164.45,0,0,0-20.92,6.29,100.56,100.56,0,0,0-18.69,9.45c-7.59,4.92-14.22,10.87-20.45,16.69s-12.12,11.43-18.63,14.93a17.81,17.81,0,0,1-15.49,1.14c-5.3-2-10.77-6.54-15.92-12.81-5.74-7-10.63-18.19-14-28.25a94.37,94.37,0,0,1-5.14-30.11,105.21,105.21,0,0,1,3.14-25.42,110.71,110.71,0,0,1,8.67-23.1,115.94,115.94,0,0,1,13.22-20.56c7.52-9.27,15.94-15.28,25.37-16.87s19.88.82,31.14,6.68Z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M1668.55,461.9c8.56,4.65,18.23,12.67,28,21.88s19.7,19.48,28.4,28.38q10.72,11,21.65,21.75c9.2,9.1,11.81,12.06,7.19,16-2.6,2.18-6.76,4.38-12.89,6.27s-14.33,3.36-24.64,4.92a122.51,122.51,0,0,0-21.58,5.54,102.69,102.69,0,0,0-19.2,8.84,133.35,133.35,0,0,0-20.93,16.11c-6.3,5.71-12.15,11.32-18.5,14.94-9.84,5.62-20.32,1.81-30.18-10.12-5.51-6.66-10.45-17-13.74-27a95.27,95.27,0,0,1-5-30.45A110.45,110.45,0,0,1,1599,489.42,108.5,108.5,0,0,1,1612.07,469c7.41-9,15.81-13.93,25.27-15s19.93,1.75,31.21,7.9Z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M1672.2,464.73c8.59,4.85,18.29,13,28.09,22.1S1720,506,1728.63,514.51Q1739.22,525,1750.18,535c9.07,8.32,11.31,11,6.92,15.06-2.48,2.26-6.49,4.54-12.5,6.46s-14.11,3.35-24.43,4.69a133.1,133.1,0,0,0-22.26,4.69,107.58,107.58,0,0,0-19.74,8.23,121,121,0,0,0-21.45,15.49c-6.39,5.58-12.23,11.16-18.43,14.88-9.63,5.78-19.61,2.7-29-8.63-5.28-6.34-10.17-15.82-13.42-25.81a95.67,95.67,0,0,1-4.93-30.71,117.11,117.11,0,0,1,3.25-26.63,113.87,113.87,0,0,1,8.62-23.67,103.3,103.3,0,0,1,12.91-20.14c7.29-8.73,15.77-12.52,25.24-13.19s20,2.63,31.29,9Z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M1675.86,467.64c8.61,5,18.32,13.18,28.12,22.2s19.63,18.74,28.27,26.88,16,14.64,21.46,19.2c9,7.54,10.81,10.23,6.65,14.39-2.35,2.36-6.21,4.72-12.09,6.67s-13.87,3.36-24.19,4.52c-7.64.85-15.67,1.77-22.9,3.78a114.44,114.44,0,0,0-20.28,7.63,112.74,112.74,0,0,0-22,14.83c-6.49,5.43-12.33,11-18.41,14.78-9.44,5.89-19,3.5-28-7.21-5.07-6-9.82-14.67-13-24.59a95.82,95.82,0,0,1-4.83-30.88,122.94,122.94,0,0,1,3.29-27.15,115.94,115.94,0,0,1,8.59-23.9c3.63-7.42,7.91-14.87,12.75-19.64,7.3-7.18,15.77-11.28,25.26-11.53S1664.53,461.06,1675.86,467.64Z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M1679.51,470.61c8.64,5.13,18.37,13.33,28.16,22.2s19.59,18.26,28.19,26,16,13.71,21.4,17.85c8.87,6.78,10.27,9.66,6.37,14-2.22,2.45-5.92,4.9-11.66,6.89s-13.61,3.39-23.93,4.37c-7.68.74-16,1-23.47,2.86a123.51,123.51,0,0,0-20.86,7,107.05,107.05,0,0,0-22.64,14.15c-6.62,5.27-12.48,10.75-18.46,14.6-9.29,6-18.39,4.25-27-5.84A68.7,68.7,0,0,1,1603,571.32a95.69,95.69,0,0,1-4.75-31,129.18,129.18,0,0,1,3.33-27.63,116.08,116.08,0,0,1,8.54-24.07c3.6-7.39,7.84-14,12.67-18.57,7.27-6.86,15.75-10.54,25.26-10.39s20.1,4.18,31.44,10.92Z"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M1683.17,473.62c8.66,5.23,18.4,13.41,28.18,22.1s19.54,17.71,28.12,25,16.54,13.58,21.27,16.36c7.66,4.51,9.8,9.45,6.15,13.92-2.08,2.55-5.61,5.1-11.21,7.13s-13.34,3.43-23.63,4.27c-7.71.63-15.87,1.1-23.92,2s-14.92,3.63-21.52,6.3a102.37,102.37,0,0,0-23.3,13.43c-6.76,5.09-12.67,10.49-18.57,14.38-9.17,6-17.87,4.93-26.13-4.54-4.66-5.35-9-13.09-12-22.29a93.85,93.85,0,0,1-4.65-30.84,132.63,132.63,0,0,1,3.36-28,116,116,0,0,1,8.47-24.19,55.92,55.92,0,0,1,12.63-17.45c7.25-6.54,15.74-9.81,25.28-9.29S1671.81,466.76,1683.17,473.62Z"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M1686.82,476.66c8.69,5.29,18.44,13.43,28.2,21.89s19.5,17.1,28,23.91a212.63,212.63,0,0,0,21,14.63c7.35,4.55,9.58,9.68,6.19,14.32-1.93,2.64-5.29,5.29-10.74,7.37s-13.06,3.5-23.31,4.21c-7.73.53-16,.85-24.13,1.53a86.48,86.48,0,0,0-22.36,5.25,100.46,100.46,0,0,0-24,12.68c-6.92,4.9-12.88,10.19-18.73,14.1-9.07,6.09-17.43,5.54-25.32-3.32-4.47-5-8.6-12.43-11.55-21.41a93.21,93.21,0,0,1-4.49-30.43,138.44,138.44,0,0,1,3.37-28.4,101.71,101.71,0,0,1,8.42-24,56.22,56.22,0,0,1,12.63-16.5,33,33,0,0,1,25.31-8.24c9.56.86,20.22,5.5,31.58,12.43Z"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M1690.47,479.71c8.71,5.34,18.46,13.38,28.21,21.58s19.46,16.41,28,22.75,16,10.2,20.46,13.11c7.07,4.6,9.41,9.91,6.3,14.72-1.78,2.75-5,5.49-10.27,7.63s-12.77,3.58-23,4.18c-7.74.45-16,.63-24.32,1.09a92.68,92.68,0,0,0-23.17,4.15,99.49,99.49,0,0,0-24.76,11.9c-7.09,4.69-13.13,9.86-18.94,13.77-9,6.08-17,6.09-24.6-2.16-4.29-4.69-8.24-11.78-11.06-20.51a93,93,0,0,1-4.28-30,142.05,142.05,0,0,1,3.39-28.69,93,93,0,0,1,8.42-23.31,52.27,52.27,0,0,1,12.6-16,32.35,32.35,0,0,1,25.35-7.23c9.59,1.18,20.27,6.06,31.65,13Z"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M1694.12,482.76c8.73,5.35,18.48,13.26,28.22,21.17s19.41,15.67,27.91,21.49,15.63,8.83,20,11.8c6.83,4.67,9.29,10.16,6.45,15.15-3.25,5.71-12.12,11.06-32.36,12.07-7.75.39-16.08.44-24.46.69s-16.76,1-24,3a100.94,100.94,0,0,0-25.55,11.1c-7.28,4.48-13.42,9.51-19.2,13.4-9,6-16.74,6.56-24-1.08-4.12-4.35-7.89-11.12-10.58-19.59a91.48,91.48,0,0,1-4-29.45,141.94,141.94,0,0,1,3.43-28.6,91,91,0,0,1,8.41-22.93A49,49,0,0,1,1637,475.51c7.25-5.63,15.79-7.75,25.41-6.28S1682.73,475.8,1694.12,482.76Z"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "M1697.76,485.81c8.74,5.31,18.5,13.05,28.22,20.64s19.37,14.86,27.86,20.15,15.2,7.68,19.46,10.73c6.62,4.74,9.2,10.42,6.65,15.58-2.93,5.92-11.39,11.51-31.48,12.38-7.73.33-16.09.27-24.57.33s-17.28,0-24.69,1.87a102.39,102.39,0,0,0-26.38,10.28c-7.49,4.25-13.74,9.12-19.53,13-9,6-16.48,7-23.42-.08-4-4-7.57-10.46-10.13-18.66a89.78,89.78,0,0,1-3.75-28.82,142.68,142.68,0,0,1,3.51-28.37,87.81,87.81,0,0,1,8.41-22.6,45.89,45.89,0,0,1,12.59-15c7.25-5.33,15.83-7.11,25.47-5.38s20.39,7,31.78,13.95Z"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M1701.4,488.82c8.76,5.26,18.52,12.81,28.22,20s19.32,14,27.8,18.73,14.72,6.75,18.91,9.89c6.44,4.82,9.15,10.67,6.89,16-2.61,6.15-10.67,12-30.57,12.73-7.72.29-16.1.13-24.65,0s-17.74-.91-25.37.7a105.75,105.75,0,0,0-27.25,9.45c-7.71,4-14.1,8.7-19.9,12.5-9,5.9-16.31,7.32-23,.85-3.81-3.71-7.26-9.81-9.69-17.72a87.54,87.54,0,0,1-3.47-28.15c.51-15.06,3-28.9,7.25-40s10.14-19.68,17.4-24.71,15.87-6.48,25.55-4.5,20.45,7.4,31.84,14.24Z"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "M1705,491.8c8.78,5.18,18.53,12.49,28.22,19.32s19.27,13,27.75,17.23,14.18,6.06,18.32,9.29c6.28,4.9,9.14,10.93,7.17,16.44-2.27,6.37-9.94,12.41-29.64,13.09-7.69.26-16.09,0-24.69-.24s-17.42-.54-25.8-.13c-11.53.55-20.42,4.5-28.36,8.25s-14.48,8.26-20.32,12c-9.07,5.79-16.18,7.61-22.58,1.7-3.67-3.39-7-9.14-9.27-16.76a84.45,84.45,0,0,1-3.18-27.43c.6-14.87,3.14-28.56,7.39-39.52s10.18-19.22,17.46-24,15.93-5.88,25.63-3.69,20.51,7.72,31.9,14.43Z"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    className: "cls-19",
    d: "M1708.66,494.73c8.79,5.06,18.53,12.1,28.2,18.51s19.81,12.93,27.71,15.62,13.61,5.64,17.7,9c6.16,5,9.17,11.19,7.49,16.87-1.94,6.59-9.22,12.86-28.69,13.49-7.67.24-16.06-.07-24.71-.46s-17.56-.88-26.09-.77c-11.8.14-21.37,3.37-29.56,6.85s-14.9,7.8-20.79,11.44c-9.16,5.65-16.12,7.82-22.28,2.47-3.56-3.09-6.7-8.5-8.88-15.82a81.34,81.34,0,0,1-2.89-26.66c.7-14.64,3.29-28.17,7.57-38.92s10.23-18.74,17.53-23.2,16-5.29,25.73-2.92,20.56,8,32,14.53Z"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    className: "cls-20",
    d: "M1712.28,497.6c8.81,4.91,18.53,11.65,28.19,17.6s19.75,11,27.41,13.73,13.25,5.69,17.32,9.12c6.06,5.1,9.22,11.45,7.84,17.31-1.61,6.8-8.5,13.28-27.74,13.89-7.62.24-16-.12-24.7-.64s-17.67-1.19-26.34-1.35a81.36,81.36,0,0,0-30.75,5.41,135.09,135.09,0,0,0-21.31,10.84c-9.27,5.5-16.12,8-22.07,3.16-3.44-2.78-6.45-7.86-8.51-14.87A78,78,0,0,1,1629,546c.81-14.4,3.45-27.73,7.77-38.25s10.29-18.25,17.63-22.42,16.07-4.74,25.84-2.21S1700.88,491.24,1712.28,497.6Z"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    className: "cls-21",
    d: "M1715.89,500.38c8.82,4.74,18.54,11.14,28.17,16.6a176.46,176.46,0,0,0,27,12c7.44,2.68,12.93,5.75,17,9.28,6,5.2,9.29,11.7,8.2,17.73-1.26,7-7.79,13.72-26.77,14.33a241.46,241.46,0,0,1-24.65-.78c-8.72-.63-17.77-1.46-26.56-1.88a88.69,88.69,0,0,0-31.93,3.93,123.26,123.26,0,0,0-21.87,10.21c-9.42,5.31-16.19,8.08-22,3.77-3.34-2.5-6.22-7.24-8.16-13.93a73.94,73.94,0,0,1-2.29-25c.92-14.12,3.62-27.23,8-37.51s10.38-17.74,17.76-21.64,16.14-4.21,26-1.54,20.67,8.3,32.06,14.42Z"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M1719.49,503.08c8.84,4.53,18.54,10.55,28.16,15.49s19.38,7.84,26.61,10.53,12.65,5.82,16.73,9.46c5.92,5.31,9.39,12,8.6,18.15-.93,7.24-7.09,14.13-25.8,14.77a217,217,0,0,1-24.59-.88c-8.73-.71-17.84-1.69-26.74-2.34-12.44-.9-24-.24-33.08,2.41a116.81,116.81,0,0,0-22.48,9.55c-9.58,5.1-16.31,8.11-21.9,4.3-3.26-2.22-6-6.63-7.84-13a70.18,70.18,0,0,1-2-24.15c1-13.81,3.83-26.69,8.25-36.71s10.48-17.21,17.9-20.85,16.23-3.7,26.07-.93,20.73,8.37,32.11,14.21Z"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    className: "cls-23",
    d: "M1723.09,505.68c8.84,4.3,18.53,9.9,28.13,14.29s19.07,6.51,26.13,9.22,12.41,5.91,16.5,9.67c5.89,5.41,9.51,12.21,9,18.55-.58,7.42-6.4,14.53-24.82,15.23a196.5,196.5,0,0,1-24.5-.95c-8.74-.78-17.89-1.9-26.88-2.75-12.62-1.2-24.85-1.48-34.19.87a111.4,111.4,0,0,0-23.14,8.85c-9.77,4.87-16.5,8.09-22,4.75-3.18-1.95-5.83-6-7.55-12.09a66,66,0,0,1-1.69-23.26c1.17-13.47,4-26.12,8.51-35.87s10.61-16.66,18.08-20.05,16.32-3.22,26.2-.37,20.78,8.38,32.16,13.91Z"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    className: "cls-24",
    d: "M1726.67,508.16c8.86,4,18.53,9.19,28.12,13s18.7,5.39,25.6,8.12a50.25,50.25,0,0,1,16.31,9.9c5.86,5.5,9.65,12.44,9.44,18.94-.25,7.63-5.72,14.91-23.86,15.69a178.82,178.82,0,0,1-24.38-1c-8.73-.84-17.91-2.07-27-3.11-12.78-1.47-25.6-2.72-35.26-.67a110.32,110.32,0,0,0-23.84,8.12c-10,4.62-16.73,8-22.06,5.12-3.12-1.7-5.67-5.45-7.29-11.2s-2.29-13.48-1.4-22.35c1.31-13.13,4.24-25.49,8.81-35s10.73-16.1,18.26-19.24,16.42-2.77,26.32.13,20.84,8.31,32.21,13.49Z"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "M1730.25,510.52c8.87,3.74,18.51,8.41,28.09,11.61s18.25,4.51,25,7.26a50.56,50.56,0,0,1,16.19,10.12c5.86,5.62,9.81,12.67,9.88,19.32.09,7.84-5.06,15.28-22.89,16.17a165.08,165.08,0,0,1-24.25-1c-8.71-.89-17.91-2.22-27-3.43-12.93-1.71-26.28-3.94-36.27-2.2a110,110,0,0,0-24.58,7.37c-10.23,4.35-17.06,7.86-22.27,5.4-6.13-2.9-10.12-14.59-8.17-31.75,1.45-12.77,4.48-24.83,9.13-34S1664,499.88,1671.53,497s16.53-2.36,26.47.57,20.88,8.19,32.25,13Z"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    className: "cls-26",
    d: "M1733.81,512.75c8.88,3.4,18.5,7.56,28.07,10.12s17.74,3.85,24.37,6.64a50.94,50.94,0,0,1,16.12,10.36c5.87,5.72,10,12.88,10.33,19.68.42,8-4.44,15.63-21.94,16.63a151.64,151.64,0,0,1-24.1-.91c-8.68-.92-17.89-2.32-27.07-3.68-13-1.94-26-3.72-37.19-3.7s-18.65,4-25.38,6.56c-10.49,4.06-17.4,7.68-22.55,5.61-6.08-2.45-9.82-13.41-7.69-30,1.6-12.4,4.74-24.14,9.47-33s11-15,18.66-17.65,16.64-2,26.62,1,20.93,8,32.28,12.38Z"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    className: "cls-27",
    d: "M1795,577.36c-8.7.58-18.77-.12-29.52-1.49s-22.17-3.41-33.23-5.09-22.4-4-31-2.79a112,112,0,0,0-21.52,5.21c-11.76,4.1-19.1,8-24.26,5.14s-8-12.88-5.91-27.61c1.75-12,5-23.42,9.82-32s11.19-14.38,18.89-16.85,16.76-1.61,26.77,1.29,21,7.77,32.32,11.66c8.88,3,18.49,6.65,28,8.54s17.17,3.45,23.7,6.28a51.48,51.48,0,0,1,16.09,10.61c6.44,6.36,11,14.47,10.85,21.92s-5.21,14.14-21.06,15.19Z"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    className: "cls-28",
    d: "M1829.41,16,1661.87,187.46l-101.16-52h0L1416,421.63h0l132.34,29.47,133.5,175.21h0l235.76-38.83h0l178.74-305.24h0L1960,240.72,1829.42,16Zm0,.06,130.53,224.68h0l136.39,41.52L1917.6,587.48,1681.87,626.3l-133.5-175.21h0l-132.31-29.46L1560.71,135.5l101.16,52h0Z"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "M1418.2,420.84l131.46,29.24h0l133.21,173.18L1916.14,586l97.1-166.13,81-137.08-135.49-41.3h0l-46.54-79.3L1828.47,18.84,1662.31,188.66h0l-100.22-51Zm264.66,202.47h0L1549.64,450.12l-131.51-29.25h0l143.92-283.26h0l100.22,51L1828.48,18.77h0l83.74,143.37,46.53,79.3,135.53,41.31h0l-81,137.11L1916.17,586h0l-233.3,37.27Z"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    className: "cls-30",
    d: "M1420.34,420.05l130.62,29h0l132.92,171.16,230.79-35.71,96.45-165.32,81-135.89-134.61-41.07h0L1911,163.78,1827.54,21.63l-164.8,168.19h0l-99.29-50Zm263.53,200.24h0L1550.94,449.12l-130.67-29h0l143.14-280.34h0l99.29,50L1827.55,21.54h0l83.51,142.19,46.51,78.45,134.64,41.09h0l-81,135.92-96.47,165.34h0l-230.83,35.71Z"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "M1422.49,419.26l129.77,28.81h0L1684.9,617.2l228.32-34.14L2009,418.55l81.05-134.7L1956.36,243h0l-46.49-77.61-83.25-141L1663.18,191h0L1564.83,142Zm262.39,198h0L1552.23,448.12,1422.4,419.3h0l142.36-277.43h0l98.36,49L1826.63,24.31h0l83.27,141L1956.4,243l133.76,40.87h0L2009.09,418.6l-95.82,164.54h0l-228.36,34.15Z"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    className: "cls-32",
    d: "M1424.63,418.47l128.94,28.6h0l132.34,167.1,225.85-32.58,95.15-163.7L2088,284.38l-132.82-40.63h0L1908.69,167l-83-139.78L1663.61,192.13h0l-97.42-48.07Zm261.26,195.77h0L1553.53,447.12l-129-28.6h0L1566.14,144h0l97.43,48.07,162.1-165h0l83,139.82,46.46,76.76L2088,284.29h0l-81,133.63-95.2,163.73h0l-225.89,32.58Z"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    className: "cls-33",
    d: "M1426.77,417.68l128.1,28.38h0l132,165.07,223.38-31,94.5-162.89,81.11-132.32L1954,244.51h0l-46.44-75.93L1824.75,30,1664,193.28h0l-96.48-47.08Zm260.12,193.54h0l-132.06-165.1-128.16-28.39h0L1567.5,146.1h0l96.5,47.1L1824.77,29.85h0l82.8,138.64,46.43,76,132,40.42h0l-81.13,132.35-94.52,162.93h0l-223.43,31Z"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    className: "cls-34",
    d: "M1428.91,416.89l127.26,28.17h0l131.76,163,220.9-29.46,93.85-162.09,81.13-131.12-131-40.18h0l-46.42-75.08L1823.82,32.75,1664.47,194.44h0l-95.55-46.1-140,268.56Zm259,191.3h0l-131.76-163L1428.8,417V417l140-268.67h0l95.56,46.1L1823.84,32.62v.05l82.56,137.45,46.42,75.07,131.1,40.2h0L2002.76,416.6l-93.88,162.12h0l-221,29.47Z"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    className: "cls-35",
    d: "M1431.06,416.1l126.41,27.95h0l131.47,161,218.43-27.9,93.2-161.28L2081.74,286,1951.6,246h0l-46.4-74.24L1822.9,35.53l-158,160.06h0l-94.61-45.11Zm257.85,189.07h0l-131.48-161-126.49-28v-.05l139.27-265.75h0l94.63,45.11,158-160.09h0l82.32,136.27,46.39,74.23,130.22,40h0l-81.18,130L1907.36,577.2h0l-218.5,27.91Z"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    className: "cls-36",
    d: "M1433.2,415.32l125.57,27.73h0l131.18,159,216-26.34,92.55-160.47,81.19-128.75-129.25-39.73h0L1904,173.35l-82-135L1665.34,196.75h0l-93.68-44.13Zm256.72,186.83h0l-131.18-159L1433.08,415.4v0l138.5-262.84h0l93.69,44.13L1822,38.16v.05l82.1,135.09,46.37,73.38,129.33,39.76v.05l-81.22,128.8L1906,575.79h0l-216,26.35Z"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    className: "cls-37",
    d: "M1435.35,414.53,1560.07,442h0L1691,599l213.49-24.78,91.9-159.66L2077.58,287l-128.36-39.51h0L1902.85,175,1821,41.1,1665.77,197.91h0L1573,154.75Zm255.58,184.59h0L1560,442.13,1435.2,414.6v-.06L1573,154.62h0l92.76,43.15,155.3-156.85v0l81.85,133.9,46.34,72.54L2077.73,287v.06l-81.24,127.61-91.93,159.7h0L1691,599.16Z"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    className: "cls-38",
    d: "M1437.49,413.74,1561.37,441h0L1692,596l211-23.22,91.26-158.85,81.24-126.37L1948,248.26h0l-46.33-71.7L1820.11,43.88,1666.2,199.06h0l-91.81-42.15ZM1691.94,596.1h0l-130.6-155-124-27.32v-.06l137-257h0l91.82,42.16,154-155.22h0l81.62,132.72,46.32,71.69,127.56,39.32v.05L1994.34,414l-91.28,158.9h0Z"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    className: "cls-39",
    d: "M1439.63,413l123,27.08h0L1693,593l208.54-21.66,90.61-158,81.27-125.18L1946.84,249h0l-46.31-70.87L1819.17,46.66,1666.63,200.22h0L1575.72,159ZM1693,593.08h0l-130.39-153L1439.46,413v-.07l136.17-254.08h0L1666.52,200,1819.2,46.48v.06l81.38,131.53,46.3,70.85L2073.59,288v.06L1992.28,413.3,1901.6,571.4h0Z"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    className: "cls-40",
    d: "M1441.78,412.16,1564,439h0l130,150.89,206.07-20.1,90-157.24,81.3-124-125.68-38.83h0l-46.29-70L1818.3,49.43,1667.07,201.37h0l-89.94-40.19ZM1694,590.05h0l-130-150.9-122.4-26.91v-.07L1577,161h0l90,40.2,151.23-152v.06l81.14,130.35,46.27,70,125.8,38.87-.05.07-81.34,124-90,157.29h0Z"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    className: "cls-41",
    d: "M1443.92,411.37,1565.28,438h0L1695,586.9l203.6-18.54,89.3-156.43,81.33-122.8-124.79-38.61h0l-46.26-69.18-80.86-129.1L1667.5,202.53h0l-89-39.21ZM1695,587h0L1565.21,438.13l-121.48-26.67v-.08L1578.4,163.14h0l89,39.22L1817.34,52v.07l80.91,129.16,46.25,69.16L2069.4,289v.07L1988,412l-89.34,156.48h0Z"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    className: "cls-42",
    d: "M1446.06,410.58,1566.58,437h0L1696,583.87l201.12-17,88.66-155.61,81.35-121.61-123.89-38.39h0L1897,182.92,1816.39,55,1667.93,203.68h0l-88.07-38.22ZM1696,584h0L1566.51,437.13l-120.65-26.46.05-.07,133.85-245.33h0l88.09,38.23L1816.41,54.79v.07l80.67,128,46.22,68.31,124,38.43v.08l-81.39,121.68L1897.24,567h0Z"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    className: "cls-43",
    d: "M1448.21,409.79,1567.88,436h0L1697,580.84l198.66-15.43,88-154.8L2065,290.18,1942,252h0l-46.21-67.49L1815.46,57.78l-147.1,147.06h0l-87.14-37.24ZM1697,581h0L1567.8,436.14,1448,409.89v-.08L1581.12,167.4h.06l87.15,37.24L1815.48,57.56v.07L1896,184.43l46.21,67.47,123.13,38.21-.05.07-81.43,120.5-88,154.87h0Z"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    className: "cls-44",
    d: "M1450.35,409l118.83,26h0L1698,577.79l196.18-13.87,87.36-154L2063,290.71l-122.11-37.94h0l-46.19-66.64L1814.53,60.56,1668.79,206h0l-86.2-36.25ZM1698,578h0L1569.1,435.14l-119-26v-.09l132.3-239.49h.06l86.22,36.26,145.8-145.49v.08L1894.8,186l46.2,66.65,122.25,38-.06.08L1981.72,410l-87.4,154.06h0Z"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    className: "cls-45",
    d: "M1452.5,408.22l118,25.78h0l128.57,140.76,193.71-12.31,86.7-153.19,81.44-118L1939.7,253.52h0l-46.17-65.8L1813.6,63.34,1669.23,207.15h0L1584,171.88ZM1699,574.93h0L1570.4,434.14l-118.14-25.82v-.09L1583.8,171.66h.06L1669.19,207,1813.63,63.1v.08l80,124.43,46.15,65.78,121.37,37.76-.06.09L1979.6,409.36l-86.74,153.26h0Z"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    className: "cls-46",
    d: "M1454.64,407.43,1571.78,433h0l128.28,138.74L1891.32,561l86-152.38,81.46-116.85-120.32-37.5h0l-46.14-65L1812.67,66.12l-143,142.18h-.05L1585.27,174ZM1700,571.91h0L1571.7,433.14l-117.3-25.6v-.1l130.8-233.65h.07l84.35,34.3L1812.7,65.87V66l79.73,123.24,46.13,64.94L2059,291.68l-.06.09-81.52,116.94-86.1,152.44h0Z"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    className: "cls-47",
    d: "M1456.78,406.64,1573.08,432h0l128,136.7,188.77-9.18L1975.26,408l81.49-115.67L1937.32,255h0l-46.12-64.11-79.44-122L1670.09,209.46h0l-83.4-33.31ZM1701,568.88h0L1573,432.14l-116.47-25.39v-.09l130-230.73h.06L1670,209.24l141.76-140.6v.09l79.49,122.07,46.11,64.08L2057,292.2l-.07.1L1975.4,408.05,1890,559.69h0Z"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    className: "cls-48",
    d: "M1458.93,405.85,1574.38,431h0l127.7,134.68,186.3-7.62,84.75-150.76,81.52-114.48-118.54-37h0L1890,192.48,1810.8,71.69,1670.52,210.61h0L1588,178.27Zm243.1,160h0L1574.29,431.14,1458.66,406l.06-.1,129.21-227.81h.07l82.48,32.33,140.36-139,.06.08,79.25,120.89,46.08,63.24,118.71,37.1-.07.09L1973.3,407.39l-84.8,150.84h0L1702,565.86Z"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    className: "cls-49",
    d: "M1461.07,405.06,1575.68,430h0l127.41,132.65,183.82-6.07L1971,406.64l81.54-113.29L1934.9,256.53h0l-46.08-62.42-79-119.61L1671,211.77h-.06l-81.53-31.34-128.3,224.65Zm242,157.77h0L1575.59,430.14l-114.8-25,.06-.1,128.44-224.89h.07l81.55,31.35,139-137.37.06.09L1889,194l46.06,62.39,117.83,36.88-.08.1L1971.2,406.75l-84.15,150h0l-184,6.07Z"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    className: "cls-50",
    d: "M1463.21,404.27,1577,429h0l127.13,130.63,181.35-4.51L1968.93,406l81.57-112.09-116.75-36.6h0l-46.06-61.58L1809,77.25,1671.39,212.92h-.06l-80.6-30.35Zm240.84,155.54h0L1576.89,429.14l-114-24.74.07-.11,127.66-222h.08l80.61,30.37L1809,77l.06.09,78.79,118.51,46,61.56,116.94,36.66-.07.1-81.64,112.19-83.5,149.23h-.06Z"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    className: "cls-51",
    d: "M1465.36,403.48,1578.29,428h0l126.83,128.6,178.88-3,82.8-148.33,81.6-110.91L1932.56,258h0l-46-60.73L1808,80,1671.8,214.05h-.06l-79.66-29.37Zm239.69,153.31h0L1578.19,428.15l-113.13-24.53.07-.12L1592,184.5h.08l79.68,29.37L1808.05,79.73l.07.09,78.54,117.34,46,60.7,116.06,36.44-.08.11-81.67,111-82.85,148.41h0Z"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    className: "cls-52",
    d: "M1467.5,402.69,1579.59,427h0l126.54,126.58,176.41-1.39,82.15-147.52L2046.32,295l-115-36.15h0l-46-59.9-78.25-116L1672.25,215.23l-78.79-28.4-126,215.86Zm238.57,151.07h0L1579.49,427.15l-112.3-24.32.07-.12,126.11-216.13h.08L1672.2,215,1807.12,82.5l.07.1,78.31,116.15,46,59.86,115.18,36.21-.08.12-81.7,109.82-82.21,147.61h-.06Z"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    className: "cls-53",
    d: "M1707.16,550.53l173.94.17L1962.6,404l81.65-108.53-114.07-35.93h0l-46-59-78-114.87L1672.7,216.47h-.06L1594.83,189,1469.65,401.9,1580.89,426h0Zm174.06.38h-.06l-174.09-.17h0L1580.79,426.15l-111.47-24.1.08-.13,125.34-213.21h.08l77.81,27.41L1806.2,85.27l.07.1,78.07,115,46,59,114.29,36-.08.11L1962.78,404.1Z"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    className: "cls-54",
    d: "M1708.17,547.5l171.47,1.73,80.85-145.9L2042.17,296,1929,260.28h0l-46-58.21-77.77-113.7L1673.12,217.54l-76.93-26.44-124.4,210,110.4,23.9h0l126,122.53Zm171.59,1.94h-.06l-171.62-1.73h0l-126-122.53-110.62-23.89.07-.12,124.57-210.3h.08l76.88,26.43L1805.27,88l.07.11,77.84,113.78,45.93,58.17,113.41,35.77-.09.12L1960.67,403.4Z"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    className: "cls-55",
    d: "M1709.18,544.47l169,3.29,80.2-145.1,81.71-106.15L1927.8,261h0l-45.94-57.36-77.53-112.5L1673.55,218.7h-.06l-75.93-25.44L1473.94,400.33,1583.49,424h0l125.67,120.5ZM1878.31,548h-.07l-169.15-3.29h0L1583.38,424.15l-109.79-23.67.08-.13L1597.46,193h.08l76,25.45,130.8-127.64.08.11,77.6,112.6,45.91,57.33,112.52,35.55-.09.12-81.79,106.26Z"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    className: "cls-56",
    d: "M1710.19,541.44l166.53,4.84L1956.27,402,2038,297l-111.39-35.25h0l-45.92-56.52-77.31-111.3L1674,219.85h-.06l-75-24.45L1476.08,399.54l108.71,23.4h0l125.38,118.48Zm166.66,5.08h-.07l-166.68-4.84h0L1584.68,423.15l-109-23.46.08-.13,123-204.46h.09l75,24.46,129.49-126,.08.11,77.36,111.42,45.89,56.48,111.64,35.33-.1.13-81.82,105.08L1876.78,546.5Z"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    className: "cls-57",
    d: "M1711.2,538.41l164.06,6.4,78.9-143.47,81.76-103.77-110.5-35h0l-45.89-55.67-77-110.13-128,124.3h-.07l-74.06-23.48L1478.22,398.75l107.87,23.19h0Zm164.19,6.64h-.07l-164.21-6.41h0L1586,422.15l-108.13-23.24.09-.14L1600.2,197.24h.09l74.08,23.48L1802.48,96.35l.08.12,77.13,110.23,45.86,55.64,110.76,35.11-.1.13-81.85,103.89-79,143.58Z"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    className: "cls-58",
    d: "M1712.22,535.38l161.58,8,78.25-142.66,81.78-102.59-109.6-34.8h0l-45.88-54.83-76.83-109L1674.85,222.16h-.07l-73.13-22.49L1480.37,398l107,23h0l124.81,114.42Zm161.72,8.21h-.08l-161.74-8h0L1587.27,421.15l-107.28-23,.08-.14L1601.54,199.4h.09l73.15,22.49L1801.55,99.13l.09.11,76.89,109.05,45.84,54.79L2034.24,298l-.11.14-81.88,102.7-78.31,142.78Z"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    className: "cls-59",
    d: "M1713.23,532.35l159.11,9.52L1949.94,400l81.81-101.4L1923,264h0l-45.84-54-76.58-107.75-125.31,121h-.07L1603,201.79,1482.5,397.17l106.18,22.76h0l124.52,112.4Zm159.25,9.78h-.08l-159.27-9.53h0L1588.61,420.2l-106.45-22.82.09-.15L1602.9,201.5h.09l72.22,21.5,125.41-121.1.09.12,76.65,107.86,45.82,53.95,109,34.67-.11.14-81.91,101.51-77.67,142Z"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    className: "cls-60",
    d: "M1714.24,529.32l156.64,11.08,76.95-141,81.84-100.2-107.82-34.36h0L1876,211.62l-76.34-106.56-124,119.41h-.07L1604.33,204,1484.66,396.38,1590,418.92h0ZM1871,540.66h-.08l-156.8-11.09h0L1589.87,419.16l-105.62-22.6.09-.16,119.93-192.77h.09l71.28,20.53L1799.7,104.67l.08.12,76.42,106.68,45.79,53.1L2030.1,299l-.12.15L1948,399.5l-77,141.16Z"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    className: "cls-61",
    d: "M1715.25,526.29l154.17,12.63,76.3-140.23,81.86-99-106.92-34.13h0l-45.8-52.3-76.1-105.38L1676.15,225.63h-.08l-70.33-19.54L1486.8,395.6l104.49,22.32h0l123.94,108.35Zm154.32,12.91h-.09l-154.33-12.65h0l-124-108.39-104.79-22.39.1-.15,119.15-189.86h.09l70.35,19.54,122.7-117.89.09.12L1875,213.06l45.77,52.26L2028,299.54l-.12.15-82,99.15L1869.57,539.2Z"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    className: "cls-62",
    d: "M1716.26,523.26,1868,537.45,1943.61,398l81.89-97.83-106-33.9h0l-45.77-51.45-75.87-104.2L1676.58,226.78h-.07l-69.4-18.56L1489,394.81l103.64,22.1h0Zm151.85,14.48H1868l-151.87-14.21h0L1592.47,417.16l-104-22.17.11-.16L1607,207.89h.1l69.41,18.56,121.34-116.27.09.12,76,104.32L1919.68,266,2026,300l-.13.15-82,98-75.72,139.56Z"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    className: "cls-63",
    d: "M1717.27,520.23,1866.5,536l75-138.61,81.91-96.64-105.13-33.68h0l-45.76-50.61-75.63-103L1677,227.94l-68.53-17.6L1491.09,394l102.8,21.89h0Zm149.38,16h-.09l-149.4-15.76h0L1593.77,416.16l-103.12-22,.1-.16,117.6-184h.1l68.48,17.58,120-114.65.09.13,75.71,103.13,45.73,50.57,105.45,33.78-.13.16-82,96.77L1866.7,536.22Z"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    className: "cls-64",
    d: "M1718.29,517.2,1865,534.51l74.35-137.8,81.94-95.45-104.2-33.46h0L1871.33,218l-75.39-101.83-118.5,112.91h-.07l-67.53-16.59L1493.23,393.23l102,21.67h0Zm146.91,17.61h-.1l-146.93-17.33h0l-123.1-102.32-102.29-21.74.11-.17,116.82-181.09h.1l67.55,16.6,118.62-113,.1.13,75.47,102,45.7,49.72,104.57,33.57-.14.16-82.06,95.59L1865.2,534.81Z"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    className: "cls-65",
    d: "M1719.3,514.17,1863.58,533l73.7-137,82-94.27L1915.9,268.55h0l-45.71-48.93L1795,119,1677.88,230.24h-.08l-66.6-15.61L1495.38,392.44l101.11,21.46h0Zm144.44,19.18h-.1l-144.46-18.88h0L1596.36,414.16l-101.45-21.53.11-.17,116-178.17h.1l66.62,15.62L1795,118.51l.1.13,75.24,100.76L1916,268.28l103.69,33.34-.14.17-82.09,94.4-73.78,137.14Z"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    className: "cls-66",
    d: "M1720.31,511.14l141.81,20.42,73.05-136.18,82-93.07-102.45-33h0L1869,221.2l-74.91-99.46L1678.31,231.4l-65.74-14.64-115,174.89,100.26,21.24h0l122.49,98.23Zm142,20.75h-.1l-142-20.45h0l-122.5-98.24L1497,391.85l.12-.18,115.27-175.25h.11l65.68,14.64,115.9-109.78.1.13,75,99.58,45.65,48,102.81,33.12-.15.16-82.12,93.22-73.13,136.33Z"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    className: "cls-67",
    d: "M1721.32,508.11l139.34,22,72.4-135.37,82-91.88L1913.5,270.08h0l-45.66-47.24-74.68-98.27-114.41,108h-.08l-64.73-13.65-114.26,172,99.42,21h0l122.2,96.2Zm139.51,22.31h-.11l-139.52-22h0L1599,412.17l-99.79-21.1.12-.19,114.5-172.33h.11l64.75,13.66,114.54-108.16.1.13,74.77,98.4,45.63,47.19,101.92,32.9-.15.17-82.15,92-72.48,135.53Z"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    className: "cls-68",
    d: "M1722.33,505.08l136.87,23.54L1931,394.06l82-90.7-100.66-32.55h0l-45.65-46.39-74.43-97.09-113,106.41h-.08L1615.3,221,1501.82,390l98.57,20.8h0L1722.3,505Zm137,23.88h-.11l-137-23.57h0L1600.3,411.21l-99-20.89.12-.19,113.73-169.4h.1l63.82,12.66,113.19-106.53.1.14,74.53,97.21,45.6,46.35,101,32.68-.16.17-82.18,90.85L1859.37,529Z"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    className: "cls-69",
    d: "M1723.35,502.05l134.39,25.09,71.12-133.77,82.05-89.48-99.77-32.33h0L1865.5,226l-74.2-95.9L1679.61,234.86h-.08l-62.87-11.68L1504,389.29l97.73,20.58h0L1723.36,502Zm134.56,25.45h-.11l-134.59-25.13h0l-121.63-92.16-98.13-20.67.14-.2,113-166.48h.1l62.89,11.68L1791.4,129.63l.11.14,74.29,96,45.58,45.5,100.16,32.46-.16.18-82.2,89.64L1858,527.49Z"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    className: "cls-70",
    d: "M1724.36,499l131.93,26.65,70.47-133,82.07-88.28L1910,272.31h0l-45.6-44.7-74-94.72L1680,236l-62-10.72L1506.11,388.5,1603,408.87h0Zm132.1,27h-.12l-132.12-26.69h0l-121.33-90.13-97.29-20.46.13-.2L1617.88,225h.1l62,10.7,110.47-103.29.11.14,74,94.85,45.57,44.6,99.28,32.24-.18.18L1927,392.91Z"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    className: "cls-71",
    d: "M1725.37,496l129.46,28.21L1924.65,392l82.09-87.1-98-31.88h0l-45.58-43.86-73.72-93.54-109,101.53-61.09-9.73-111.1,160.29,96,20.15h0ZM1855,524.57h-.12L1725.23,496.3h0l-121-88.11L1507.77,388l.14-.2,111.4-160.65h.1l61,9.72,109.11-101.66.11.14,73.78,93.7,45.53,43.81,98.39,32-.17.19-82.26,87.27Z"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    className: "cls-72",
    d: "M1726.38,493l127,29.77,69.17-131.35,82.11-85.91-97.08-31.65h0l-45.55-43-73.49-92.35-107.6,99.91h-.08l-60.07-8.73L1510.4,386.92l95.19,19.94h0Zm127.16,30.15h-.12l-127.18-29.81h0l-120.76-86.08-95.62-20,.15-.2L1620.6,229.22h.11L1680.8,238l107.75-100,.11.14,73.59,92.48,45.5,43,97.52,31.8-.19.19-82.28,86.08-69.26,131.52Z"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    className: "cls-73",
    d: "M1727.39,489.93l124.52,31.32,68.5-130.52h0L2002.57,306l-96.18-31.43h0l-45.53-42.17-73.25-91.17-106.24,98.28h-.08l-59.14-7.75L1512.54,386.13l94.35,19.72h0l120.47,84.06Zm124.7,31.72H1852l-124.71-31.37h0l-120.47-84L1512,386.36l.15-.21L1622,231.35h.1l59.17,7.76,106.39-98.42.12.14,73.34,91.3,45.48,42.12,96.64,31.58-.19.2-82.32,84.89-68.61,130.72Z"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    className: "cls-74",
    d: "M1728.41,486.9l122,32.88,67.85-129.71h0l82.16-83.53-95.28-31.2h0L1859.67,234l-73-90L1681.8,240.65l-58.29-6.78-108.8,151.49,93.5,19.51h0l120.19,82Zm122.22,33.29h-.14l-122.23-32.93h0l-120.18-82-94-19.59.16-.22,109.07-151.88h.11l58.23,6.78,105-96.8.12.15,73.11,90.1,45.5,41.2,95.75,31.35-.2.21-82.34,83.71-68,129.91Z"
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    className: "cls-75",
    d: "M1729.42,483.87,1849,518.3l67.2-128.9h0l82.19-82.33-94.39-31h0l-45.48-40.48-72.78-88.8-103.51,95h-.08l-57.3-5.79-108,148.57,92.66,19.28h0Zm119.75,34.86H1849L1729.27,484.2h0l-119.89-80-93.13-19.39.16-.22,108.3-149h.11l57.3,5.8,103.67-95.18.12.15,72.88,88.92,45.43,40.44,94.87,31.14-.21.21-82.37,82.52L1849.2,518.7Z"
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    className: "cls-76",
    d: "M1730.43,480.84l117.1,36,66.55-128.09h0l82.21-81.14-93.49-30.76h0l-45.46-39.64-72.53-87.62L1682.65,243h-.08l-56.34-4.81L1519,383.77l91.81,19.07h0l119.61,78Zm117.29,36.43h-.15l-117.32-36.06-119.6-78L1518.35,384l.17-.23,107.53-146h.1l56.37,4.82L1784.83,149l.12.15,72.64,87.74L1903,276.5l94,30.92-.21.21L1914.38,389l-66.66,128.31Z"
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    className: "cls-77",
    d: "M1521.13,383l91,18.85h0l119.34,76,114.61,37.53L1912,388.08h0l82.24-80-92.6-30.53h0l-45.43-38.8-72.3-86.43-100.79,91.77H1683l-55.42-3.83Zm325.13,132.8h-.15l-114.8-37.59-119.36-76-91.47-19,.18-.23,106.75-143.11h.1l55.43,3.83,101-91.92.12.15,72.4,86.55,45.39,38.75,93.11,30.7-.22.21-82.44,80.15-66,127.5Z"
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    className: "cls-78",
    d: "M1523.27,382.19l90.12,18.64h0l119,74,112.14,39.09,65.25-126.46h0L1992,308.7l-91.7-30.3h0l-45.41-38-72.06-85.25-99.43,90.15h-.08L1629,242.4ZM1844.8,514.34l-.16-.05-112.33-39.16-119.06-73.95-90.64-18.74.18-.24,106-140.19h.1l54.5,2.85,99.6-90.31.13.15,72.17,85.37L1900.63,278l92.23,30.48-.23.22-82.46,79L1844.8,514.4Z"
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    className: "cls-79",
    d: "M1525.42,381.4l89.27,18.42h0l118.76,71.92,109.68,40.65,64.6-125.65h0L1990,309.16l-90.81-30.07h0L1853.84,242,1782,157.88l-98.07,88.52h-.07l-53.56-1.87Zm317.92,131.48-.16-.06-109.86-40.71-118.77-71.93-89.81-18.53.19-.24,105.2-137.27L1683.8,246l98.2-88.67.13.15,71.93,84.19,45.34,37.06L1990.79,309l-.24.22L1908.07,387l-64.73,125.89Z"
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    className: "cls-80",
    d: "M1527.57,380.61,1616,398.83l118.47,69.9,107.21,42.2,64-124.84h0L1988,309.7l-89.91-29.85h0l-45.36-36.27-71.59-82.88-96.7,86.89h-.08l-52.62-.88Zm314.31,130.81-.16-.06-107.4-42.28-118.47-69.9-89-18.31.2-.25,104.42-134.34h.1l52.64.88,96.89-87.06.13.15,71.69,83,45.31,36.22,90.47,30-.24.22L1906,386.33Z"
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    className: "cls-81",
    d: "M1529.71,379.82l87.61,18L1735.5,465.7l104.74,43.76,63.3-124h0l82.32-75.19-89-29.63h0l-45.34-35.42-71.36-81.7-95.34,85.27h-.07l-51.69.1-103.34,131ZM1840.43,510l-.17-.07L1735.33,466.1l-118.18-67.87L1529,380.08l.2-.25,103.65-131.42h.1l51.71-.1,95.53-85.44.13.15,71.46,81.83,45.29,35.37L1986.65,310l-.25.23-82.54,75.4Z"
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    className: "cls-82",
    d: "M1531.86,379l86.75,17.78,117.9,65.85L1838.78,508l62.65-123.22h0l82.35-74-88.11-29.4h0l-45.32-34.57-71.12-80.52-94,83.64h-.08L1634.39,251ZM1839,508.5l-.18-.07L1736.33,463l-117.88-65.84-87.32-17.89.21-.26,102.87-128.5h.09l50.79-1.08,94.17-83.81.13.15,71.22,80.64L1895.88,281l88.7,29.6-.26.23L1901.75,385Z"
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    className: "cls-83",
    d: "M1534,378.25l85.91,17.56,117.6,63.83,99.81,46.86,62-122.4h0l82.36-72.81-87.24-29.2-45.3-33.73L1778.29,169l-92.61,82h-.07l-49.83,2.06ZM1837.51,507l-.18-.08-100-47-117.6-63.81-86.48-17.67.21-.27,102.1-125.58h.09l49.86-2.06,92.81-82.19.13.15,71,79.46,45.24,33.68L1982.52,311l-.27.23-82.6,73Z"
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    className: "cls-84",
    d: "M1536.15,377.46l85.06,17.35,117.32,61.8L1835.86,505l61.35-121.59h0l82.38-71.63-86.34-29L1848,249.93l-70.64-78.15-91.26,80.39h-.1l-48.9,3.05-101,122.24Zm299.9,128.13-.19-.1L1738.34,457l-117.29-61.79-85.66-17.46.22-.27,101.32-122.65h.09l48.92-3,91.46-80.57.14.15,70.75,78.28,45.21,32.84,87,29.16-.28.24-82.63,71.84L1836.1,505.66Z"
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    className: "cls-85",
    d: "M1538.31,376.67l84.2,17.13,117,59.77,94.87,50,60.69-120.77h0l82.41-70.44L1892,283.62l-45.25-32-70.4-77-89.89,78.76-48,4L1538.29,376.7Zm296.28,127.46-.19-.1-95.05-50-117-59.76L1537.52,377l.23-.27L1638.29,257h.09l48-4,90.1-79,.14.16,70.51,77.09,45.19,32,86.07,28.94-83,70.77-60.85,121.09Z"
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    className: "cls-86",
    d: "M1540.45,375.88l83.36,16.92,116.74,57.74,92.4,51.53,60-120h0l82.43-69.24-84.55-28.52-45.22-31.2-70.17-75.78L1687,254.48h-.07l-47,5-99.42,116.39Zm292.68,126.79-.19-.11-92.59-51.64-116.7-57.73-84-17,.24-.28,99.76-116.8h.09l47.06-5,88.74-77.32.14.15L1846,252.8l45.13,31.2,85.19,28.72-.3.25-82.69,69.46-60.2,120.29Z"
  })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    className: "cls-87",
    d: "M1542.6,375.09l82.46,16.68,116.5,55.74,89.93,53.09,59.39-119.15h0l82.44-68.06-83.64-28.28-45.21-30.36-69.93-74.6-87.16,75.51h-.07l-46.11,6Zm289.08,126.12-.21-.12-90.11-53.19-116.44-55.71-83.14-16.81L1641,261.21l46.21-6,87.38-75.7.15.15,70,74.73,45.14,30.31,84.31,28.5-.3.25-82.72,68.28-59.55,119.48Z"
  })), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    className: "cls-88",
    d: "M1544.75,374.31l81.61,16.46,116.21,53.71L1830,499.12l58.73-118.33h0l82.47-66.87-82.75-28.06-45.18-29.51-69.7-73.42-85.8,73.88h-.06l-45.19,7-97.85,110.55Zm285.47,125.44-.21-.13-87.65-54.75-116.14-53.68-82.32-16.6.26-.29,98.22-111,45.28-7,86-74.08.15.15,69.8,73.54,45.12,29.47,83.43,28.28-.31.26L1889.11,381,1830.2,499.69Z"
  })), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    className: "cls-89",
    d: "M1546.9,373.52l80.76,16.24,115.92,51.69,85,56.19,58.08-117.52h0l82.49-65.68-81.8-27.81-45.21-28.69-69.46-72.23L1688.25,258h-.06L1644,265.89ZM1828.76,498.3l-.22-.14-85.18-56.32-115.84-51.65L1546,373.81l.27-.3,97.44-108,44.35-8,84.66-72.46.15.16,69.57,72.35,45.12,28.64,82.53,28.05-.33.26L1887,380.41Z"
  })), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    className: "cls-90",
    d: "M1549.05,372.73l79.91,16,115.63,49.67,82.53,57.74,57.43-116.7h0L1967.06,315l-80.9-27.59L1841,259.51l-69.23-71.06-83.07,70.64h-.06L1645.33,268l-96.28,104.7ZM1827.3,496.84l-.22-.15-82.71-57.88-115.55-49.62L1548.16,373l.27-.3,96.67-105.11h.07l43.34-8.93,83.31-70.83.15.15,69.33,71.17,45.1,27.79,81.65,27.84-.33.26-82.8,64.72Z"
  })), _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    className: "cls-91",
    d: "M1551.2,371.94l79.06,15.81,115.34,47.63,80.07,59.3,56.77-115.88h0L1965,315.5l-80-27.35-45.2-27-68.94-69.84-81.71,69-42.46,9.93L1551.16,372Zm274.64,123.45-.23-.17-80.24-59.43-115.25-47.6-79.84-15.95.29-.31,95.89-102.19h.06l42.42-9.92,82-69.21,69.23,70.12,45.09,27L1966,315.3l-.34.27-82.83,63.53-57,116.29Z"
  })), _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    className: "cls-92",
    d: "M1553.35,371.15l78.21,15.6,115.08,45.61h0l77.55,60.81,56.12-115.07h0l82.56-62.1-79.1-27.13-45.18-26.2L1769.94,194l-80.35,67.38h0l-41.47,10.89-94.72,98.85Zm271,122.78-.23-.18-77.75-61-115-45.58-79-15.75.3-.31,95.11-99.26h.06l41.49-10.9L1770,193.37l.16.15L1839,262.31l45,26.12,79.9,27.4-83.21,62.61-56.33,115.49Z"
  })), _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    className: "cls-93",
    d: "M1555.5,370.37l77.36,15.37,114.79,43.59h0l75.07,62.36,55.47-114.25h0l82.56-60.92-78.2-26.9-45.15-25.35L1769,196.79l-79,65.75h0l-40.55,11.88-93.93,95.93Zm267.42,122.11-.24-.2-75.27-62.53L1632.73,386.2l-78.19-15.54.31-.31L1649.18,274l40.62-11.9,79.23-66,.16.15,68.6,67.6,45,25.28,79,27.18-83.25,61.42-55.68,114.7Z"
  })), _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    className: "cls-94",
    d: "M1557.65,369.58l76.51,15.15,114.51,41.57h0l72.6,63.91,54.81-113.44h.05L1958.74,317l-77.3-26.68-45.13-24.5-68.23-66.29-77.62,64.13h0l-39.62,12.86-93.15,93ZM1821.46,491l-.24-.21-72.81-64.08L1634,385.2l-77.37-15.32.32-.32,93.56-93.41h0l39.63-12.87L1768,198.94l68.52,66.57,45,24.43,78.15,27-83.29,60.25-55,113.89Z"
  })), _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    className: "cls-95",
    d: "M1559.8,368.79l75.66,14.94,114.22,39.54h0l70.12,65.44L1874,376.14h.06l82.6-58.54-76.41-26.45-45.11-23.66-68-65.1-76.25,62.5h0l-38.7,13.85-92.36,90.08ZM1820,489.57l-.25-.23-70.33-65.63L1635.33,384.2l-76.54-15.11.33-.32,92.78-90.49h0l38.7-13.85,76.52-62.72.16.15,68.13,65.23,45,23.59,77.27,26.75-.39.28-82.94,58.78Z"
  })), _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
    className: "cls-96",
    d: "M1562,368l74.8,14.72,113.93,37.52h0l67.66,67,53.5-111.79h.06l82.62-57.35-75.51-26.23L1834,269.05l-67.76-63.92L1691.33,266l-37.8,14.84Zm256.58,120.12-.25-.25-67.87-67.19-113.79-37.47L1561,368.31l.35-.33,92-87.57h0l37.78-14.83,75.17-61.11.15.15,67.89,64.05,45,22.75,76.4,26.53-.4.28-83,57.59-53.75,112.31Z"
  })), _path97 || (_path97 = /*#__PURE__*/React.createElement("path", {
    className: "cls-97",
    d: "M1564.11,367.22l74,14.5,113.65,35.49v.05l65.18,68.53,52.86-111h0l82.64-56.17-74.6-26-45.07-22-67.52-62.74-73.55,59.26L1654.9,283l-90.79,84.24Zm253,119.45-.25-.27-65.39-68.74L1638,382.21l-75-14.69.37-.33,91.22-84.64h0l36.84-15.82,73.82-59.47.16.15,67.65,62.86,44.94,21.9,75.53,26.31-.42.29-83,56.41L1817,486.69Z"
  })), _path98 || (_path98 = /*#__PURE__*/React.createElement("path", {
    className: "cls-98",
    d: "M1566.26,366.43l73.1,14.28,113.36,33.47v.06l62.71,70.06,52.2-110.15h.06l82.65-55-73.71-25.77-45-21.13-67.28-61.55-72.13,57.6-36,16.82-90,81.32Zm249.35,118.79-63.17-70.59-113.2-33.42-74.08-14.47.38-.35L1656,284.68h0l36-16.82L1764.39,210l.16.15L1832,271.84l44.92,21.05,74.65,26.1-.43.29-83,55.22-52.47,110.72Z"
  })), _path99 || (_path99 = /*#__PURE__*/React.createElement("path", {
    className: "cls-99",
    d: "M1568.42,365.64l72.24,14.07,113.08,31.44v.06L1814,482.82l51.54-109.33h.06l82.67-53.79-72.8-25.54-45-20.28-67-60.38-70.78,56-35,17.81-89.21,78.39Zm245.73,118.13-.26-.31-60.45-71.85-112.9-31.4L1567.28,366l.4-.35,89.68-78.8,35-17.79,71.08-56.23.16.15,67.18,60.5,44.89,20.21,73.78,25.88-.44.29-83,54-51.83,109.93Z"
  })), _path100 || (_path100 = /*#__PURE__*/React.createElement("path", {
    className: "cls-100",
    d: "M1570.57,364.86,1642,378.7l112.79,29.42.06.07,57.76,73.14,50.89-108.51,82.75-52.64-71.9-25.31-45-19.44-66.8-59.19-69.42,54.36L1659,289.4l-88.4,75.46Zm242.12,117.46-58.24-73.73-112.61-29.37-72.44-14.05.41-.36L1658.67,289l34.13-18.81,69.73-54.6.16.14L1829.63,275l44.87,19.37L1947.41,320l-83.54,53.13-51.18,109.14Z"
  })), _path101 || (_path101 = /*#__PURE__*/React.createElement("path", {
    className: "cls-101",
    d: "M1572.73,364.07l70.53,13.63,112.51,27.39.06.08,55.29,74.67,50.23-107.68h.06l82.71-51.41-71-25.09-45-18.59-66.57-58-68.06,52.73-33.18,19.78-87.61,72.54Zm238.49,116.81-.26-.36-55.5-75-112.32-27.34-71.62-13.84.43-.36,88-72.88,33.18-19.79,68.38-53,.17.14,66.7,58.13,44.84,18.52,72,25.45-.47.3-83.11,51.66-50.54,108.35Z"
  })), _path102 || (_path102 = /*#__PURE__*/React.createElement("path", {
    className: "cls-102",
    d: "M1574.89,363.28l69.67,13.41,112.22,25.37,52.89,76.29,49.57-106.86h.07L1942,321.23l-70.09-24.85-45-17.75-66.33-56.83L1694,272.91l-32.24,20.75-86.83,69.62Zm234.87,116.15-53.3-76.89-112-25.32-70.8-13.63,87.76-70.37,32.25-20.76,67-51.36.16.15,66.47,56.94,44.82,17.68,71.16,25.23-83.62,50.77-49.9,107.56Z"
  })), _path103 || (_path103 = /*#__PURE__*/React.createElement("path", {
    className: "cls-103",
    d: "M1577.05,362.5l68.8,13.19,112,23.34.06.09,50.36,77.74,48.91-106h.07l82.73-49-69.19-24.62-44.92-16.91-66.1-55.64-65.33,49.48-31.3,21.74-86,66.7ZM1808.3,478l-.27-.42-50.57-78.05-111.71-23.3-70-13.41.48-.38,86.54-67.08,31.3-21.73,65.67-49.74.17.14,66.22,55.75,44.79,16.84,70.3,25-83.66,49.59Z"
  })), _path104 || (_path104 = /*#__PURE__*/React.createElement("path", {
    className: "cls-104",
    d: "M1579.21,361.71,1758.82,396l.06.1,47.89,79.26L1855,370.17l.08-.05,82.74-47.84-113.15-40.43h0l-65.86-54.46Z"
  })), _path105 || (_path105 = /*#__PURE__*/React.createElement("path", {
    className: "cls-105",
    d: "M1363,194.13c3.34-1,6.58,3.56,9.88,12.35s6.58,21.8,10.52,37.12c2.15,8.36,4.45,17.31,6.93,26.16s5.14,17.6,8,25.44c5.27,14.62,12.36,24.87,19.06,29.16s4.81,7.44-2.22,10.32-18.89,3.16-28.75-4.07c-8.19-6-15.3-15.83-22.4-27.45-6.21-10.16-12.47-22.17-18.84-33.1s-12.92-20.63-19.13-27.34c-8.83-9.55-13.81-16-14-22.85s3.94-13.05,9-16.93c5.71-4.38,12.57-6.3,19.85-6.87C1349.08,195.41,1357.49,195.74,1363,194.13Z"
  })), _path106 || (_path106 = /*#__PURE__*/React.createElement("path", {
    className: "cls-106",
    d: "M1364.15,195.86c3.38-.89,6.65,3.67,10,12.44s6.64,21.73,10.66,36.91c2.21,8.32,4.57,17.19,7.13,25.92s5.32,17.3,8.23,25c5.4,14.21,12.56,24,19.2,28.12s4.77,7.36-2.26,10.49-19,4.19-29-2.39c-8.37-5.51-15.59-14.92-22.76-26.29-6.26-9.95-12.54-21.88-18.86-32.95s-12.74-21.11-18.81-28.27c-8.56-10.09-13.38-17.05-13.61-24.05s3.61-13.07,8.47-16.85c5.52-4.3,12.24-6.12,19.47-6.56,8.15-.5,16.6,0,22.21-1.48Z"
  })), _path107 || (_path107 = /*#__PURE__*/React.createElement("path", {
    className: "cls-107",
    d: "M1365.33,197.59c3.43-.8,6.73,3.78,10.1,12.53s6.71,21.65,10.82,36.66c2.26,8.26,4.71,17,7.35,25.64s5.5,17,8.5,24.44c5.56,13.8,12.72,23.13,19.31,27.14s4.73,7.28-2.29,10.66-19.18,5.18-29.32-.75c-8.57-5-15.9-14-23.13-25.11-4.22-6.48-8.43-13.89-12.63-21.43s-8.4-15.18-12.56-22.14A182.09,182.09,0,0,0,1329.21,247c-8.3-10.6-13-18.09-13.28-25.23a20.46,20.46,0,0,1,8-16.82c5.35-4.24,11.93-6,19.11-6.28,8.08-.35,16.56.3,22.31-1Z"
  })), _path108 || (_path108 = /*#__PURE__*/React.createElement("path", {
    className: "cls-108",
    d: "M1366.51,199.34c3.48-.72,6.82,3.87,10.23,12.59s6.79,21.55,11,36.37c2.33,8.2,4.85,16.88,7.59,25.33s5.69,16.66,8.79,23.9c5.71,13.36,12.84,22.29,19.36,26.18s4.7,7.23-2.31,10.84-19.27,6.13-29.56.86c-8.76-4.49-16.21-13-23.53-23.89-4.26-6.32-8.51-13.63-12.72-21.13s-8.4-15.2-12.52-22.29q-5.56-9.74-12.08-18.89c-8.06-11.07-12.57-19.08-13-26.37a20.19,20.19,0,0,1,7.51-16.83c5.17-4.2,11.61-5.84,18.75-6C1352.09,199.76,1360.62,200.56,1366.51,199.34Z"
  })), _path109 || (_path109 = /*#__PURE__*/React.createElement("path", {
    className: "cls-109",
    d: "M1367.69,201.1c3.54-.64,6.91,4,10.37,12.64s6.89,21.43,11.21,36c2.4,8.12,5,16.68,7.84,25s5.89,16.29,9.09,23.31c5.88,12.91,13.13,21.59,19.37,25.29s4.67,7.18-2.33,11-19.33,7-29.77,2.43c-9-4-16.53-12-23.94-22.63-4.31-6.15-8.59-13.34-12.83-20.8s-8.41-15.18-12.5-22.39-8.11-13.88-11.91-19.45c-7.85-11.5-12.19-20-12.64-27.49a20.08,20.08,0,0,1,7-16.88c5-4.18,11.32-5.74,18.42-5.82,8-.09,16.52.85,22.57-.25Z"
  })), _path110 || (_path110 = /*#__PURE__*/React.createElement("path", {
    className: "cls-110",
    d: "M1368.88,202.87c3.59-.58,7,4,10.51,12.67s7,21.29,11.43,35.69c2.48,8,5.18,16.47,8.12,24.6q4.13,11.55,9.38,22.64c5.93,12.3,13.16,20.93,19.35,24.5s4.64,7.15-2.33,11.18-19.37,7.91-29.95,4c-9.17-3.42-16.87-11.06-24.37-21.34a228.77,228.77,0,0,1-13-20.42c-4.26-7.4-8.45-15.13-12.52-22.44s-8-14.17-11.77-20c-7.65-11.89-11.84-20.93-12.35-28.55s2.51-13.45,6.62-17c4.85-4.17,11-5.66,18.1-5.64,7.89,0,16.52,1.11,22.73.12Z"
  })), _path111 || (_path111 = /*#__PURE__*/React.createElement("path", {
    className: "cls-111",
    d: "M1370.06,204.65c3.66-.51,7.12,4.1,10.68,12.68s7.13,21.13,11.68,35.29c2.55,7.94,5.36,16.24,8.4,24.18s6.39,15.44,9.66,21.95c6,11.91,13.17,20.31,19.3,23.76s4.62,7.12-2.33,11.36-19.36,8.71-30.09,5.42c-9.38-2.88-17.21-10.05-24.81-20a201.64,201.64,0,0,1-13.1-20c-4.3-7.32-8.5-15.05-12.55-22.44s-8-14.42-11.66-20.44c-7.48-12.24-11.5-21.78-12.07-29.58s2.26-13.61,6.21-17.12c4.68-4.17,10.75-5.6,17.79-5.48,7.84.14,16.52,1.34,22.89.46Z"
  })), _path112 || (_path112 = /*#__PURE__*/React.createElement("path", {
    className: "cls-112",
    d: "M1371.26,206.43c3.71-.44,7.23,4.17,10.85,12.67s7.27,21,12,34.86c2.63,7.83,5.54,16,8.7,23.72s6.6,14.93,9.9,21.26c6,11.53,13.18,19.71,19.24,23.06,6.24,3.43,4.6,7.11-2.32,11.53s-19.31,9.47-30.19,6.84c-9.59-2.33-17.56-9-25.28-18.68a182.72,182.72,0,0,1-13.25-19.58c-4.34-7.22-8.56-14.94-12.61-22.39s-8-14.62-11.58-20.85c-7.32-12.56-11.19-22.57-11.82-30.56s2-13.81,5.82-17.29c4.53-4.19,10.49-5.57,17.49-5.36,7.81.24,16.54,1.56,23.1.77Z"
  })), _path113 || (_path113 = /*#__PURE__*/React.createElement("path", {
    className: "cls-113",
    d: "M1372.45,208.22c3.78-.39,7.36,4.22,11,12.65s7.42,20.74,12.24,34.37c2.73,7.71,5.74,15.69,9,23.23s6.79,14.41,10.12,20.56c6,11.18,13.17,19.15,19.18,22.4,6.19,3.35,4.58,7.11-2.31,11.72s-19.23,10.16-30.26,8.18c-9.81-1.75-17.91-8-25.75-17.29a164.63,164.63,0,0,1-13.43-19.12c-4.39-7.12-8.64-14.8-12.7-22.29s-7.92-14.8-11.51-21.22c-7.18-12.83-10.92-23.29-11.59-31.48s1.81-14,5.44-17.51c4.39-4.21,10.24-5.56,17.22-5.26,7.76.33,16.56,1.76,23.29,1.06Z"
  })), _path114 || (_path114 = /*#__PURE__*/React.createElement("path", {
    className: "cls-114",
    d: "M1373.65,210c3.85-.35,7.49,4.24,11.26,12.59s7.58,20.51,12.55,33.84c2.82,7.59,6,15.39,9.35,22.7s6.94,13.9,10.29,19.88c6.08,10.83,13.16,18.61,19.1,21.78,6.15,3.27,4.57,7.12-2.29,11.9s-19.1,10.79-30.29,9.47c-10-1.18-18.28-6.92-26.23-15.89a147.7,147.7,0,0,1-13.62-18.61c-4.44-7-8.74-14.63-12.81-22.16s-8-14.92-11.48-21.5c-7.06-13.08-10.66-24-11.39-32.35s1.61-14.28,5.09-17.76c4.25-4.26,10-5.57,17-5.2C1357.86,209.1,1366.73,210.63,1373.65,210Z"
  })), _path115 || (_path115 = /*#__PURE__*/React.createElement("path", {
    className: "cls-115",
    d: "M1374.86,211.81c3.92-.3,7.63,4.27,11.48,12.53s7.76,20.25,12.88,33.26c2.93,7.44,6.21,15.14,9.7,22.11s7.06,13.41,10.44,19.23c6.1,10.5,13.13,18.1,19,21.19,6.11,3.22,4.55,7.15-2.26,12.09s-18.94,11.36-30.28,10.7c-10.27-.6-18.65-5.85-26.73-14.46a133.39,133.39,0,0,1-13.83-18.09c-4.5-6.88-8.85-14.44-12.94-22s-7.94-15-11.47-21.78c-7-13.29-10.44-24.56-11.21-33.17s1.4-14.54,4.75-18c4.11-4.32,9.75-5.6,16.7-5.16C1358.8,210.74,1367.74,212.36,1374.86,211.81Z"
  })), _path116 || (_path116 = /*#__PURE__*/React.createElement("path", {
    className: "cls-116",
    d: "M1376.08,213.61c4-.26,7.77,4.28,11.71,12.43s8,20,13.25,32.65c3,7.28,6.48,14.71,10,21.45s7.17,13,10.57,18.63c6.11,10.19,13.08,17.62,18.91,20.65,6.07,3.16,4.54,7.18-2.23,12.27s-18.74,11.85-30.23,11.85c-10.5,0-19-4.76-27.25-13a122.55,122.55,0,0,1-14-17.54c-4.57-6.74-9-14.21-13.1-21.74s-8-15.11-11.48-22c-6.88-13.47-10.26-25.08-11.07-33.91s1.22-14.83,4.43-18.36c4-4.39,9.53-5.66,16.47-5.16,7.67.55,16.69,2.25,24,1.77Z"
  })), _path117 || (_path117 = /*#__PURE__*/React.createElement("path", {
    className: "cls-117",
    d: "M1377.32,215.4c4.07-.23,7.92,4.28,12,12.31s8.17,19.66,13.62,32q4.71,10.6,10.36,20.77c3.62,6.5,7.28,12.53,10.7,18,6.13,9.89,13,17.16,18.8,20.14,6,3.12,4.53,7.22-2.19,12.45A69.62,69.62,0,0,1,1410.44,344c-10.73,1.56-19.43-3.58-27.78-11.43a112.15,112.15,0,0,1-14.28-17,237.71,237.71,0,0,1-13.26-21.47c-4.16-7.51-8-15.14-11.53-22.15-6.81-13.61-10.1-25.52-10.95-34.59s1-15.14,4.12-18.71c3.87-4.47,9.32-5.74,16.26-5.19,7.64.61,16.74,2.38,24.3,2Z"
  })), _path118 || (_path118 = /*#__PURE__*/React.createElement("path", {
    className: "cls-118",
    d: "M1378.56,217.2c4.15-.21,8.09,4.26,12.23,12.16s8.39,19.32,14,31.27c3.27,6.94,7,13.78,10.65,20.06s7.39,12.11,10.82,17.49c6.14,9.61,13,16.73,18.68,19.67,6,3.1,4.52,7.28-2.14,12.64a73.24,73.24,0,0,1-30,13.68c-10.84,2-19.81-2.29-28.31-9.75A103.43,103.43,0,0,1,1370,318.05a211.35,211.35,0,0,1-13.47-21.16c-4.2-7.47-8.09-15.14-11.59-22.26-6.76-13.72-10-25.9-10.86-35.2s.87-15.48,3.83-19.09c3.75-4.57,9.11-5.84,16-5.24,7.63.65,16.82,2.48,24.61,2.1Z"
  })), _path119 || (_path119 = /*#__PURE__*/React.createElement("path", {
    className: "cls-119",
    d: "M1379.82,219c4.24-.18,8.26,4.23,12.51,12s8.64,19,14.46,30.52c3.4,6.74,7.19,13.27,10.93,19.33s7.48,11.71,10.93,17c6.13,9.34,12.9,16.31,18.54,19.23,6,3.08,4.52,7.34-2.08,12.83a77.4,77.4,0,0,1-29.87,14.46c-10.93,2.45-20.17-1-28.82-8.09-7.47-6.09-15-15.23-21.82-25.71a308.47,308.47,0,0,1-18.32-33.17c-6.72-13.79-9.88-26.2-10.81-35.74s.71-15.83,3.55-19.49c3.64-4.69,8.92-6,15.87-5.34C1362.51,217.46,1371.78,219.34,1379.82,219Z"
  })), _path120 || (_path120 = /*#__PURE__*/React.createElement("path", {
    className: "cls-120",
    d: "M1381.09,220.76c4.33-.17,8.45,4.19,12.81,11.79s8.9,18.56,14.92,29.7c3.53,6.54,7.37,12.76,11.17,18.61s7.58,11.32,11,16.44c6.13,9.08,12.82,15.93,18.41,18.83,5.91,3.07,4.52,7.41-2,13s-18.1,12.14-29.71,15.18c-11,2.88-20.52.22-29.32-6.42-7.6-5.74-15.24-14.55-22.22-24.84a265.69,265.69,0,0,1-18.54-33c-6.7-13.84-9.82-26.41-10.78-36.2s.56-16.2,3.29-19.93c3.52-4.81,8.73-6.11,15.68-5.45,7.62.72,17,2.64,25.28,2.3Z"
  })), _path121 || (_path121 = /*#__PURE__*/React.createElement("path", {
    className: "cls-121",
    d: "M1382.38,222.53c4.42-.17,8.64,4.12,13.13,11.56s9.22,18.22,15.39,28.83c3.64,6.26,7.54,12.25,11.4,17.88s7.65,11,11.12,15.95c6.13,8.84,12.73,15.57,18.26,18.47,5.87,3.07,4.52,7.48-2,13.2s-17.94,12.43-29.53,15.86c-11.11,3.28-20.85,1.44-29.81-4.78-7.73-5.37-15.52-13.85-22.63-23.92a235.38,235.38,0,0,1-18.8-32.82c-6.7-13.87-10.2-25.6-10.81-36.56s.43-16.62,3-20.43c3.42-5,8.56-6.26,15.53-5.59C1364.35,220.92,1373.83,222.87,1382.38,222.53Z"
  })), _path122 || (_path122 = /*#__PURE__*/React.createElement("path", {
    className: "cls-122",
    d: "M1383.68,224.29c4.53-.18,8.86,4,13.48,11.3s9.58,17.76,15.86,27.88c3.73,6,7.7,11.76,11.61,17.2s7.73,10.59,11.2,15.47c6.12,8.61,12.65,15.23,18.12,18.13,5.82,3.09,4.52,7.57-1.87,13.39s-17.78,12.69-29.34,16.48c-11.19,3.68-21.16,2.64-30.28-3.15-7.86-5-15.82-13.13-23.06-23a213.82,213.82,0,0,1-19.09-32.56c-6.71-13.86-10.21-25.75-10.9-36.78s.33-17.11,2.85-21c3.32-5.11,8.39-6.46,15.38-5.77,7.63.74,17.22,2.71,26,2.36Z"
  })), _path123 || (_path123 = /*#__PURE__*/React.createElement("path", {
    className: "cls-123",
    d: "M1385,226c4.63-.19,9.07,3.93,13.83,11s9.94,17.23,16.34,26.88c3.81,5.76,7.85,11.28,11.8,16.53s7.81,10.24,11.29,15c6.1,8.39,12.54,14.91,18,17.82,5.79,3.11,4.54,7.67-1.78,13.58s-17.6,12.92-29.12,17.06c-11.26,4-21.44,3.8-30.74-1.56-8-4.6-16.12-12.39-23.51-22a191.09,191.09,0,0,1-19.41-32.23c-6.73-13.82-10.25-25.85-11-37s.23-17.59,2.66-21.56c3.22-5.27,8.22-6.65,15.24-6,7.64.75,17.35,2.72,26.46,2.35Z"
  })), _path124 || (_path124 = /*#__PURE__*/React.createElement("path", {
    className: "cls-124",
    d: "M1386.36,227.76c4.74-.2,9.3,3.83,14.21,10.69s10.3,16.64,16.79,25.83c3.9,5.52,8,10.81,12,15.87s7.88,9.91,11.36,14.59c6.08,8.18,12.44,14.62,17.79,17.54,5.74,3.14,4.54,7.77-1.69,13.77s-17.4,13.14-28.88,17.59-21.72,4.92-31.18,0c-8.14-4.22-16.43-11.64-24-21S1358.52,302,1353,290.86c-6.77-13.75-10.32-25.89-11.15-37.05s.12-18.06,2.46-22.12c3.13-5.45,8.07-6.88,15.12-6.21C1367.11,226.21,1376.94,228.18,1386.36,227.76Z"
  })), _path125 || (_path125 = /*#__PURE__*/React.createElement("path", {
    className: "cls-125",
    d: "M1387.73,229.47c4.85-.24,9.54,3.69,14.61,10.33s10.66,16,17.24,24.74c4,5.28,8.15,10.36,12.19,15.24s7.94,9.59,11.42,14.17c6.06,8,12.33,14.35,17.63,17.3,5.69,3.18,4.55,7.88-1.6,14s-17.19,13.33-28.62,18.07-22,6-31.6,1.55c-8.28-3.82-16.75-10.87-24.45-19.92s-14.58-20.23-20.15-31.38c-6.83-13.66-10.42-25.89-11.33-37.1s0-18.51,2.27-22.68c3-5.63,7.93-7.12,15-6.46,7.69.71,17.65,2.66,27.38,2.18Z"
  })), _path126 || (_path126 = /*#__PURE__*/React.createElement("path", {
    className: "cls-126",
    d: "M1389.13,231.16c5-.28,9.8,3.53,15,9.93s11,15.31,17.68,23.62c4.06,5.05,8.29,9.92,12.37,14.62s8,9.28,11.47,13.78c6,7.8,12.22,14.09,17.46,17.08,5.65,3.23,4.57,8-1.48,14.14s-17,13.51-28.34,18.52-22.19,7-32,3c-8.43-3.42-17.07-10.1-25-18.85s-14.9-19.74-20.56-30.87c-6.9-13.54-10.54-25.85-11.54-37.09s-.09-18.94,2.08-23.22c3-5.84,7.79-7.38,14.92-6.76,7.72.68,17.81,2.6,27.88,2Z"
  })), _path127 || (_path127 = /*#__PURE__*/React.createElement("path", {
    className: "cls-127",
    d: "M1390.55,232.82c5.1-.32,10.06,3.35,15.46,9.5s11.34,14.58,18.1,22.47c4.13,4.83,8.42,9.48,12.54,14s8,9,11.52,13.4c6,7.63,12.1,13.87,17.28,16.9,5.61,3.28,4.59,8.11-1.36,14.33s-16.75,13.66-28,18.92c-11.49,5.35-22.4,8-32.4,4.5-8.58-3-17.4-9.31-25.46-17.75s-15.23-19.22-21-30.3c-7-13.41-10.68-25.76-11.77-37s-.21-19.35,1.88-23.74c2.88-6.05,7.67-7.66,14.85-7.07C1369.9,231.59,1380.14,233.47,1390.55,232.82Z"
  })), _path128 || (_path128 = /*#__PURE__*/React.createElement("path", {
    className: "cls-128",
    d: "M1392,234.45c5.23-.37,10.35,3.16,15.93,9s11.65,13.81,18.49,21.3c8.41,9.21,17.33,17.81,24.27,26.48,6,7.48,12,13.66,17.09,16.74,5.58,3.34,4.62,8.24-1.23,14.51s-16.5,13.8-27.72,19.29c-11.52,5.63-22.57,8.93-32.77,5.89-8.73-2.59-17.74-8.5-26-16.62s-15.59-18.67-21.47-29.68c-7.07-13.24-10.85-25.62-12-36.91s-.33-19.74,1.69-24.25c2.8-6.27,7.54-8,14.78-7.42,7.79.58,18.18,2.4,29,1.63Z"
  })), _path129 || (_path129 = /*#__PURE__*/React.createElement("path", {
    className: "cls-129",
    d: "M1393.48,236.05c5.37-.43,10.64,2.94,16.41,8.53s11.95,13,18.86,20.13c8.55,8.78,17.54,17.05,24.46,25.58,5.94,7.32,11.84,13.46,16.91,16.6,5.54,3.42,4.64,8.37-1.09,14.7s-16.25,13.91-27.38,19.6c-11.55,5.91-22.74,9.8-33.12,7.25-8.89-2.18-18.08-7.69-26.51-15.47s-16-18.09-22-29c-7.18-13-11-25.44-12.34-36.74s-.45-20.09,1.49-24.73c2.73-6.51,7.44-8.28,14.73-7.8,7.85.52,18.39,2.28,29.54,1.36Z"
  })), _path130 || (_path130 = /*#__PURE__*/React.createElement("path", {
    className: "cls-130",
    d: "M1395,237.62c5.51-.51,11,2.66,16.92,8s12.22,12.23,19.19,18.94c8.7,8.36,17.75,16.32,24.65,24.72,5.9,7.18,11.71,13.29,16.73,16.48,5.49,3.5,4.67,8.51-1,14.89s-16,14-27,19.89c-11.56,6.16-22.87,10.59-33.44,8.54-9-1.75-18.43-6.86-27.06-14.3s-16.34-17.47-22.48-28.29c-7.29-12.84-11.25-25.21-12.66-36.51s-.59-20.43,1.29-25.19c2.65-6.76,7.33-8.61,14.69-8.2,7.9.45,18.61,2.12,30.15,1Z"
  })), _path131 || (_path131 = /*#__PURE__*/React.createElement("path", {
    className: "cls-131",
    d: "M1396.53,239.16c5.67-.6,11.33,2.46,17.44,7.39s12.48,11.42,19.52,17.76c8.83,7.95,17.93,15.61,24.81,23.9,5.86,7.05,11.58,13.13,16.54,16.4,5.45,3.58,4.7,8.65-.8,15.06s-15.69,14.09-26.64,20.14c-11.57,6.4-23,11.33-33.75,9.78-9.22-1.32-18.79-6-27.61-13.12s-16.75-16.82-23-27.5a97.86,97.86,0,0,1-13-36.24c-1.53-11.28-.74-20.73,1.07-25.62,2.59-7,7.23-9,14.67-8.63,8,.36,18.84,1.94,30.79.67Z"
  })), _path132 || (_path132 = /*#__PURE__*/React.createElement("path", {
    className: "cls-132",
    d: "M1398.11,240.65c5.82-.7,11.71,2.19,18,6.74S1428.8,258,1435.89,264c9,7.56,18.12,14.94,25,23.11,5.81,6.94,11.43,13,16.34,16.34,5.4,3.67,4.74,8.79-.64,15.24s-15.39,14.15-26.23,20.36a104.82,104.82,0,0,1-17.2,8.14c-5.69,2-11.36,3.33-16.85,2.81-9.37-.89-19.14-5.19-28.17-11.91s-17.16-16.16-23.6-26.69a95.49,95.49,0,0,1-13.38-35.9c-1.65-11.25-.9-21,.85-26,2.52-7.27,7.14-9.32,14.65-9.08,8,.26,19.1,1.73,31.47.25Z"
  })), _path133 || (_path133 = /*#__PURE__*/React.createElement("path", {
    className: "cls-133",
    d: "M1399.73,242.1c6-.8,12.1,1.87,18.49,6s13,9.86,20.1,15.5c9.09,7.17,18.29,14.28,25.12,22.36,5.77,6.82,11.3,12.88,16.15,16.29,5.36,3.77,4.78,9-.46,15.42s-15.09,14.2-25.81,20.54a110.62,110.62,0,0,1-17.25,8.53c-5.73,2.14-11.48,3.79-17.07,3.53-9.55-.44-19.51-4.34-28.74-10.69s-17.59-15.46-24.19-25.82a93.46,93.46,0,0,1-13.79-35.52c-1.78-11.22-1.08-21.21.61-26.39,2.46-7.54,7.06-9.7,14.65-9.56C1375.65,242.47,1386.91,243.82,1399.73,242.1Z"
  })), _path134 || (_path134 = /*#__PURE__*/React.createElement("path", {
    className: "cls-134",
    d: "M1401.39,243.5c6.15-.92,12.48,1.48,19,5.28s13.19,9.1,20.38,14.41c9.21,6.79,18.45,13.65,25.25,21.64,5.72,6.73,11.15,12.79,16,16.28,5.32,3.87,4.82,9.1-.28,15.59s-14.76,14.23-25.36,20.69a116.88,116.88,0,0,1-17.27,8.89,56.67,56.67,0,0,1-17.29,4.17c-9.76.6-19.88-3.44-29.33-9.41s-18-14.75-24.8-24.92A91.19,91.19,0,0,1,1353.42,281c-1.91-11.17-1.26-21.4.37-26.72,2.4-7.83,7-10.1,14.66-10.07,8.2,0,19.65,1.24,32.94-.75Z"
  })), _path135 || (_path135 = /*#__PURE__*/React.createElement("path", {
    className: "cls-135",
    d: "M1403.08,244.85c6.33-1,12.86,1,19.51,4.48s13.42,8.37,20.65,13.35c9.33,6.43,18.6,13.06,25.37,21,5.67,6.64,11,12.7,15.76,16.28,5.28,4,4.86,9.25-.1,15.76s-14.42,14.24-24.89,20.81a123,123,0,0,1-17.29,9.23,61,61,0,0,1-17.49,4.7c-9.93,1-20.26-2.48-29.93-8.06a81.23,81.23,0,0,1-25.43-24,88.94,88.94,0,0,1-14.68-34.6c-2-11.11-1.46-21.55.12-27,2.34-8.11,6.9-10.5,14.69-10.6C1377.65,246.08,1389.31,247.14,1403.08,244.85Z"
  })), _path136 || (_path136 = /*#__PURE__*/React.createElement("path", {
    className: "cls-136",
    d: "M1404.83,246.15c6.51-1.2,13.23.56,20,3.64s13.63,7.66,20.9,12.33c9.45,6.08,18.74,12.48,25.48,20.34,5.61,6.55,10.86,12.62,15.56,16.29,5.23,4.1,4.91,9.41.1,15.93s-14.07,14.24-24.4,20.9a126,126,0,0,1-17.29,9.54,65.09,65.09,0,0,1-17.7,5.22c-10.09,1.33-20.63-1.54-30.52-6.73a78.07,78.07,0,0,1-26.08-23,86,86,0,0,1-15.16-34.07c-2.2-11-1.69-21.65-.16-27.27,2.29-8.41,6.84-10.93,14.73-11.16,8.38-.24,20.26.65,34.54-2Z"
  })), _path137 || (_path137 = /*#__PURE__*/React.createElement("path", {
    className: "cls-137",
    d: "M1406.61,247.39c6.71-1.35,13.59,0,20.48,2.78s13.84,7,21.15,11.34c9.56,5.73,18.87,11.93,25.57,19.73,5.57,6.48,10.72,12.57,15.37,16.34,5.19,4.21,5,9.56.3,16.09s-13.71,14.23-23.89,21a131.54,131.54,0,0,1-17.28,9.84,69.44,69.44,0,0,1-17.88,5.7c-10.25,1.67-21-.63-31.13-5.41a75.17,75.17,0,0,1-26.75-22,83.49,83.49,0,0,1-15.67-33.5c-2.34-10.95-1.91-21.71-.44-27.47,2.23-8.72,6.78-11.37,14.79-11.75,8.48-.4,20.58.31,35.38-2.67Z"
  })), _path138 || (_path138 = /*#__PURE__*/React.createElement("path", {
    className: "cls-138",
    d: "M1408.44,248.56c6.91-1.52,13.94-.49,21,1.91s14,6.27,21.37,10.37c9.67,5.41,19,11.42,25.66,19.17,5.51,6.41,10.58,12.53,15.17,16.39,5.15,4.33,5,9.73.52,16.26s-13.33,14.2-23.36,21a136.57,136.57,0,0,1-17.25,10.12,75.26,75.26,0,0,1-18.06,6.16c-10.42,2-21.41.26-31.75-4.13a72.61,72.61,0,0,1-27.43-20.93,80.74,80.74,0,0,1-16.2-32.87c-2.5-10.86-2.17-21.72-.74-27.64,2.18-9,6.72-11.81,14.85-12.35,4.29-.29,9.46-.15,15.53-.51a134.35,134.35,0,0,0,20.74-2.94Z"
  })), _path139 || (_path139 = /*#__PURE__*/React.createElement("path", {
    className: "cls-139",
    d: "M1410.32,249.67c7.12-1.7,14.26-1.06,21.39,1s14.23,5.62,21.58,9.44c9.78,5.09,19.13,10.93,25.74,18.65,5.45,6.35,10.43,12.5,15,16.46,5.11,4.46,5.09,9.89.75,16.41s-13,14.16-22.81,21A139.42,139.42,0,0,1,1454.73,343a79.75,79.75,0,0,1-18.22,6.6c-10.58,2.32-21.81,1.11-32.38-2.87A70.62,70.62,0,0,1,1376,326.9a77.83,77.83,0,0,1-16.76-32.21c-2.66-10.76-2.44-21.69-1.06-27.76,2.13-9.35,6.67-12.27,14.93-13,4.35-.38,9.61-.34,15.83-.83a140.34,140.34,0,0,0,21.37-3.45Z"
  })), _path140 || (_path140 = /*#__PURE__*/React.createElement("path", {
    className: "cls-140",
    d: "M1412.25,250.72a43.78,43.78,0,0,1,21.81.1c7.23,1.75,14.41,5,21.79,8.55,9.88,4.78,19.23,10.46,25.8,18.15,5.4,6.3,10.29,12.49,14.78,16.55,5.06,4.58,5.14,10.05,1,16.56s-12.55,14.1-22.24,21a141.74,141.74,0,0,1-17.19,10.6,84.45,84.45,0,0,1-18.38,7,60.06,60.06,0,0,1-33-1.65,69.13,69.13,0,0,1-28.84-18.75,75.09,75.09,0,0,1-17.33-31.5c-2.84-10.63-2.73-21.61-1.4-27.82,2.08-9.68,6.63-12.75,15-13.65,4.42-.47,9.77-.54,16.14-1.17A142.28,142.28,0,0,0,1412.25,250.72Z"
  })), _path141 || (_path141 = /*#__PURE__*/React.createElement("path", {
    className: "cls-141",
    d: "M1414.22,251.67a46.13,46.13,0,0,1,22.21-.78c7.34,1.43,14.59,4.35,22,7.67,10,4.49,19.33,10,25.87,17.7,5.33,6.26,10.13,12.49,14.57,16.66,5,4.71,5.21,10.21,1.23,16.71s-12.13,14-21.65,20.94a143.54,143.54,0,0,1-17.09,10.83,89,89,0,0,1-18.52,7.42,63.43,63.43,0,0,1-33.65-.46,67.83,67.83,0,0,1-29.55-17.63,72.32,72.32,0,0,1-18-30.73c-3-10.5-3-21.47-1.75-27.84,2-10,6.58-13.23,15.11-14.33,4.48-.57,9.94-.76,16.47-1.54a141.6,141.6,0,0,0,22.7-4.6Z"
  })), _path142 || (_path142 = /*#__PURE__*/React.createElement("path", {
    className: "cls-142",
    d: "M1416.21,252.53a48.93,48.93,0,0,1,22.61-1.65c7.44,1.14,14.76,3.76,22.17,6.84,10.08,4.2,19.43,9.62,25.91,17.29,5.27,6.23,10,12.5,14.38,16.77,5,4.84,5.28,10.37,1.48,16.85s-11.71,14-21,20.88a144.68,144.68,0,0,1-17,11,92.74,92.74,0,0,1-18.66,7.8,67.12,67.12,0,0,1-64.58-15.8,69.57,69.57,0,0,1-18.54-30c-3.2-10.36-3.37-21.3-2.13-27.82,2-10.33,6.55-13.72,15.23-15,4.55-.68,10.11-1,16.81-1.94A141.9,141.9,0,0,0,1416.21,252.53Z"
  })), _path143 || (_path143 = /*#__PURE__*/React.createElement("path", {
    className: "cls-143",
    d: "M1418.24,253.3a51.61,51.61,0,0,1,23-2.48c7.55.84,14.93,3.17,22.34,6,10.18,3.93,19.52,9.24,26,16.9,5.21,6.21,9.84,12.53,14.18,16.9,4.94,5,5.36,10.54,1.74,17s-11.26,13.86-20.41,20.79a146.42,146.42,0,0,1-16.9,11.21,98.13,98.13,0,0,1-18.78,8.17,71.46,71.46,0,0,1-34.94,1.78,66.32,66.32,0,0,1-50.21-44.46c-3.39-10.21-3.72-21.06-2.52-27.73,1.92-10.67,6.52-14.22,15.35-15.75,4.63-.8,10.3-1.25,17.17-2.37a144.54,144.54,0,0,0,24-6Z"
  })), _path144 || (_path144 = /*#__PURE__*/React.createElement("path", {
    className: "cls-144",
    d: "M1420.3,254a55,55,0,0,1,23.37-3.31c7.64.56,15.08,2.62,22.5,5.27,10.27,3.66,19.6,8.88,26,16.56,5.15,6.18,9.7,12.55,14,17,4.9,5.11,5.43,10.69,2,17.12s-10.82,13.76-19.76,20.69a147.57,147.57,0,0,1-16.78,11.37,102.17,102.17,0,0,1-18.9,8.51,76.29,76.29,0,0,1-35.59,2.83,67.29,67.29,0,0,1-31.78-14.14,64.7,64.7,0,0,1-19.84-28.27c-3.58-10-4.09-20.79-2.93-27.6,1.87-11,6.49-14.73,15.48-16.5,4.71-.92,10.5-1.5,17.54-2.81A151.45,151.45,0,0,0,1420.3,254Z"
  })), _path145 || (_path145 = /*#__PURE__*/React.createElement("path", {
    className: "cls-145",
    d: "M1422.38,254.6a58.58,58.58,0,0,1,23.74-4.11,81.51,81.51,0,0,1,22.65,4.52c10.36,3.42,19.67,8.56,26,16.26,5.08,6.16,9.54,12.6,13.79,17.19,4.86,5.25,5.51,10.85,2.28,17.24s-10.35,13.66-19.09,20.57a146.35,146.35,0,0,1-16.65,11.52,107.19,107.19,0,0,1-19,8.84,84.08,84.08,0,0,1-24.19,4.38,74.65,74.65,0,0,1-23.77-3,65.26,65.26,0,0,1-20.82-10.5,62.35,62.35,0,0,1-20.52-27.37c-3.78-9.87-4.48-20.46-3.36-27.42,1.81-11.35,6.46-15.25,15.63-17.26,4.78-1,10.69-1.79,17.93-3.3A156.83,156.83,0,0,0,1422.38,254.6Z"
  })), _path146 || (_path146 = /*#__PURE__*/React.createElement("path", {
    className: "cls-146",
    d: "M1424.49,255.13a62.21,62.21,0,0,1,24.11-4.89,78.81,78.81,0,0,1,22.79,3.81c10.44,3.19,19.73,8.27,26,16,5,6.16,9.41,12.65,13.6,17.35,4.82,5.39,5.6,11,2.57,17.36s-9.88,13.54-18.41,20.43a145.92,145.92,0,0,1-16.49,11.65,110.7,110.7,0,0,1-19.08,9.14,88.87,88.87,0,0,1-24.62,4.94,78.58,78.58,0,0,1-24.25-2.21,65.77,65.77,0,0,1-21.35-9.71,60.33,60.33,0,0,1-21.21-26.45c-4-9.67-4.89-20.07-3.81-27.18,1.76-11.68,6.43-15.76,15.79-18,4.87-1.19,10.9-2.08,18.33-3.8a167,167,0,0,0,26-8.39Z"
  })), _path147 || (_path147 = /*#__PURE__*/React.createElement("path", {
    className: "cls-147",
    d: "M1426.63,255.58a66.18,66.18,0,0,1,24.45-5.63,75.61,75.61,0,0,1,22.92,3.13c10.53,3,19.79,8,26,15.75,5,6.16,9.26,12.72,13.41,17.52,4.77,5.53,5.68,11.16,2.86,17.48s-9.39,13.4-17.7,20.26a142.83,142.83,0,0,1-16.33,11.76,114,114,0,0,1-19.16,9.44,93.58,93.58,0,0,1-25,5.47,83.6,83.6,0,0,1-24.75-1.45,66.38,66.38,0,0,1-21.86-8.91,58.43,58.43,0,0,1-21.93-25.48c-4.2-9.48-5.32-19.64-4.29-26.89,1.71-12,6.42-16.3,16-18.86,5-1.33,11.12-2.39,18.76-4.33A179.19,179.19,0,0,0,1426.63,255.58Z"
  })), _path148 || (_path148 = /*#__PURE__*/React.createElement("path", {
    className: "cls-148",
    d: "M1428.79,256a70.37,70.37,0,0,1,24.79-6.36,73.45,73.45,0,0,1,23,2.48c10.61,2.75,19.85,7.76,26,15.56,4.88,6.16,9.12,12.79,13.22,17.7,4.73,5.66,5.77,11.3,3.16,17.58s-8.89,13.26-17,20.08a140,140,0,0,1-16.15,11.87,118.25,118.25,0,0,1-19.23,9.7,98.88,98.88,0,0,1-25.43,6,90.22,90.22,0,0,1-25.26-.73,68.12,68.12,0,0,1-22.39-8.11,56.78,56.78,0,0,1-22.65-24.49c-4.42-9.26-5.77-19.16-4.78-26.55,1.65-12.36,6.4-16.82,16.14-19.68,5-1.48,11.35-2.72,19.19-4.89A193.71,193.71,0,0,0,1428.7,256Z"
  })), _path149 || (_path149 = /*#__PURE__*/React.createElement("path", {
    className: "cls-149",
    d: "M1431,256.27a74.69,74.69,0,0,1,25.13-7.06,71,71,0,0,1,23.15,1.87c10.69,2.54,19.88,7.55,26,15.4,4.81,6.17,9,12.86,13,17.87,4.69,5.8,5.86,11.45,3.47,17.68s-8.38,13.12-16.23,19.89a136.11,136.11,0,0,1-16,11.95,121.9,121.9,0,0,1-19.28,10,103.13,103.13,0,0,1-25.82,6.46,97.67,97.67,0,0,1-25.79,0,69.9,69.9,0,0,1-22.92-7.3,55.35,55.35,0,0,1-23.39-23.47c-4.64-9.05-6.24-18.63-5.3-26.15,1.6-12.71,6.39-17.37,16.33-20.53,5.15-1.64,11.59-3.06,19.65-5.49A208.36,208.36,0,0,0,1431,256.27Z"
  })), _path150 || (_path150 = /*#__PURE__*/React.createElement("path", {
    className: "cls-150",
    d: "M1433.17,256.52a79.23,79.23,0,0,1,25.45-7.75,69.63,69.63,0,0,1,23.25,1.29c10.77,2.36,19.93,7.37,26,15.28,4.75,6.19,8.83,12.94,12.84,18.06,4.65,5.93,6,11.59,3.78,17.77s-7.85,13-15.47,19.68a131.82,131.82,0,0,1-15.74,12A124.35,124.35,0,0,1,1474,343.08a114.06,114.06,0,0,1-52.53,7.52,71.94,71.94,0,0,1-23.44-6.49,54.15,54.15,0,0,1-24.15-22.43c-4.87-8.81-6.74-18.05-5.84-25.7,1.54-13,6.37-17.9,16.53-21.39,5.25-1.8,11.84-3.42,20.12-6.11A231.37,231.37,0,0,0,1433.17,256.52Z"
  })), _path151 || (_path151 = /*#__PURE__*/React.createElement("path", {
    className: "cls-151",
    d: "M1435.39,256.7a84,84,0,0,1,25.77-8.4,68,68,0,0,1,23.34.74c10.84,2.18,20,7.22,26,15.19,4.68,6.21,8.69,13,12.65,18.26,4.6,6.06,6,11.72,4.1,17.84s-7.32,12.8-14.69,19.47A128.83,128.83,0,0,1,1497,331.86a125.62,125.62,0,0,1-19.34,10.44,111.47,111.47,0,0,1-26.58,7.35,116.84,116.84,0,0,1-26.88,1.21,74.44,74.44,0,0,1-24-5.69,53.17,53.17,0,0,1-24.92-21.36c-5.1-8.56-7.25-17.42-6.39-25.19,1.47-13.37,6.39-18.46,16.74-22.27,5.33-2,12.08-3.81,20.6-6.78a255,255,0,0,0,29.1-12.87Z"
  })), _path152 || (_path152 = /*#__PURE__*/React.createElement("path", {
    className: "cls-152",
    d: "M1437.63,256.82a88.64,88.64,0,0,1,26.07-9,66.58,66.58,0,0,1,23.43.22c10.91,2,20,7.1,25.94,15.15,4.61,6.23,8.55,13.12,12.46,18.44,4.56,6.19,6.15,11.85,4.43,17.92s-6.78,12.62-13.9,19.23a123.6,123.6,0,0,1-15.26,12.1,128.63,128.63,0,0,1-19.35,10.65,115.4,115.4,0,0,1-26.94,7.76,130.08,130.08,0,0,1-27.45,1.77,77.77,77.77,0,0,1-24.49-4.89c-11.79-4.56-20.35-11.95-25.69-20.27s-7.47-17.54-7-24.68c.89-12.39,6.36-19,16.95-23.13,5.45-2.14,12.35-4.2,21.11-7.46S1426.89,262.38,1437.63,256.82Z"
  })), _path153 || (_path153 = /*#__PURE__*/React.createElement("path", {
    className: "cls-153",
    d: "M1439.89,256.88a94,94,0,0,1,26.37-9.63,65.81,65.81,0,0,1,23.5-.27c11,1.88,20,7,25.9,15.14,4.54,6.26,8.4,13.23,12.28,18.64,4.52,6.32,6.25,12,4.76,18s-6.23,12.45-13.09,19a118,118,0,0,1-15,12.13,130.16,130.16,0,0,1-19.35,10.85,118,118,0,0,1-27.28,8.14,144.4,144.4,0,0,1-28,2.28,82,82,0,0,1-25-4.09c-12-4.12-20.9-11.11-26.48-19.16s-7.91-17.15-7.53-24.18c.68-12.3,6.32-19.4,17.14-23.94,5.57-2.33,12.69-4.47,21.64-8.19S1429,262.68,1439.89,256.88Z"
  })), _path154 || (_path154 = /*#__PURE__*/React.createElement("path", {
    className: "cls-154",
    d: "M1442.17,256.88a99.47,99.47,0,0,1,26.64-10.2,64.44,64.44,0,0,1,23.57-.72c11,1.75,20,7,25.86,15.17,4.48,6.29,8.26,13.32,12.09,18.84,4.48,6.44,6.36,12.09,5.11,18s-5.67,12.26-12.27,18.72a114.12,114.12,0,0,1-14.72,12.14,133.27,133.27,0,0,1-19.34,11,121.22,121.22,0,0,1-27.61,8.49,149.69,149.69,0,0,1-28.64,2.76,91.19,91.19,0,0,1-25.51-3.32c-12.29-3.67-21.45-10.26-27.28-18s-8.35-16.73-8.1-23.65c.46-12.21,6.26-19.81,17.33-24.73,5.68-2.53,13.06-4.94,22.16-9s19.59-9.5,30.71-15.54Z"
  })), _path155 || (_path155 = /*#__PURE__*/React.createElement("path", {
    className: "cls-155",
    d: "M1444.45,256.84a105,105,0,0,1,26.93-10.75A63.46,63.46,0,0,1,1495,245c11.11,1.63,20,6.92,25.8,15.23,4.41,6.33,8.12,13.43,11.91,19,4.44,6.56,6.46,12.2,5.45,18.08s-5.1,12.07-11.43,18.45a106.55,106.55,0,0,1-14.43,12.13,134.39,134.39,0,0,1-19.3,11.19,122.65,122.65,0,0,1-27.93,8.83,163,163,0,0,1-29.22,3.22,98.47,98.47,0,0,1-26-2.6c-12.53-3.23-22-9.4-28.09-16.9s-8.8-16.29-8.67-23.1c.23-12.11,6.17-20.2,17.51-25.52,5.81-2.73,13.42-5.44,22.68-9.81s19.91-10.1,31.21-16.36Z"
  })), _path156 || (_path156 = /*#__PURE__*/React.createElement("path", {
    className: "cls-156",
    d: "M1446.76,256.74A110.16,110.16,0,0,1,1474,245.48a62.53,62.53,0,0,1,23.67-1.53c11.18,1.52,20,6.93,25.75,15.33,4.35,6.37,8,13.54,11.73,19.23,4.39,6.67,6.57,12.3,5.8,18.11s-4.52,11.87-10.58,18.17a100.63,100.63,0,0,1-14.12,12.11A133.16,133.16,0,0,1,1497,338.27c-8.15,4-18.13,7-28.23,9.15a174.83,174.83,0,0,1-29.81,3.65,107.65,107.65,0,0,1-26.57-1.91c-12.77-2.79-22.56-8.54-28.9-15.75s-9.27-15.85-9.27-22.53c0-12,6.1-20.55,17.71-26.3,5.93-2.93,13.77-6,23.18-10.65s20.24-10.71,31.72-17.19Z"
  })), _path157 || (_path157 = /*#__PURE__*/React.createElement("path", {
    className: "cls-157",
    d: "M1449.07,256.6a116.08,116.08,0,0,1,27.45-11.75,61.82,61.82,0,0,1,23.71-1.89c11.24,1.44,20,7,25.69,15.47,4.28,6.41,7.85,13.65,11.55,19.42,4.35,6.78,6.68,12.39,6.15,18.13s-3.93,11.67-9.72,17.88A96.36,96.36,0,0,1,1520.12,326a135.34,135.34,0,0,1-19.22,11.51c-8.18,4.06-18.27,7.21-28.52,9.44a188.33,188.33,0,0,1-30.38,4,119.05,119.05,0,0,1-27.13-1.25c-13-2.37-23.11-7.68-29.72-14.59s-9.74-15.38-9.87-22c-.23-11.89,6-20.87,17.89-27,6.07-3.16,14.13-6.54,23.69-11.52s20.57-11.3,32.21-18Z"
  })), _path158 || (_path158 = /*#__PURE__*/React.createElement("path", {
    className: "cls-158",
    d: "M1451.4,256.42a121.37,121.37,0,0,1,27.69-12.21,60.91,60.91,0,0,1,23.75-2.22c11.29,1.36,20,7,25.61,15.65,4.22,6.46,7.72,13.76,11.37,19.6,4.31,6.89,6.8,12.48,6.52,18.14S1543,306.86,1537.5,313a89.6,89.6,0,0,1-13.44,12,135.49,135.49,0,0,1-19.15,11.65c-8.2,4.15-18.4,7.39-28.8,9.72a203.12,203.12,0,0,1-30.94,4.4,134.31,134.31,0,0,1-27.7-.64c-13.24-1.95-23.66-6.83-30.54-13.43s-10.22-14.89-10.48-21.33c-.48-11.78,5.9-21.17,18.08-27.81,6.2-3.38,14.47-7.12,24.18-12.41s20.87-11.87,32.69-18.74Z"
  })), _path159 || (_path159 = /*#__PURE__*/React.createElement("path", {
    className: "cls-159",
    d: "M1453.73,256.2a126.15,126.15,0,0,1,27.93-12.64,60,60,0,0,1,23.77-2.51A33.93,33.93,0,0,1,1531,256.9c4.15,6.51,7.57,13.87,11.19,19.79,4.26,7,6.9,12.55,6.88,18.14s-2.74,11.26-8,17.27a83.22,83.22,0,0,1-13.09,12,134.86,134.86,0,0,1-19.07,11.77c-8.2,4.23-18.5,7.55-29,10a214.76,214.76,0,0,1-31.5,4.72,150.84,150.84,0,0,1-28.27-.07c-13.47-1.53-24.22-6-31.37-12.25s-10.71-14.4-11.1-20.71c-.72-11.64,5.79-21.43,18.27-28.54,6.34-3.61,14.8-7.73,24.66-13.3s21.18-12.44,33.15-19.49Z"
  })), _path160 || (_path160 = /*#__PURE__*/React.createElement("path", {
    className: "cls-160",
    d: "M1456.07,255.94a132.69,132.69,0,0,1,28.16-13c8.75-2.68,16.7-3.54,23.79-2.77a33.35,33.35,0,0,1,25.47,16.11c4.09,6.56,7.44,14,11,20,4.22,7.07,7,12.62,7.26,18.12s-2.14,11.05-7.06,17A77.19,77.19,0,0,1,1532,323.21a134.34,134.34,0,0,1-19,11.89c-8.21,4.3-18.61,7.7-29.3,10.2a229.21,229.21,0,0,1-32,5,175,175,0,0,1-28.87.46c-13.69-1.13-24.77-5.12-32.19-11.09s-11.21-13.87-11.73-20.06a29,29,0,0,1,4.5-17.17c3.07-4.75,7.55-8.29,13.95-12.09s15.13-8.35,25.12-14.21,21.48-13,33.61-20.21Z"
  })), _path161 || (_path161 = /*#__PURE__*/React.createElement("path", {
    className: "cls-161",
    d: "M1458.42,255.66c10-6,19.59-10.62,28.38-13.41s16.75-3.75,23.8-3c11.45,1.22,19.91,7.41,25.38,16.39,4,6.62,7.3,14.08,10.83,20.13,4.18,7.16,7.14,12.67,7.63,18.1s-1.52,10.83-6.14,16.63a72.29,72.29,0,0,1-12.3,11.86,134,134,0,0,1-18.86,12c-8.22,4.38-18.72,7.85-29.55,10.42A242.47,242.47,0,0,1,1455,350a201.43,201.43,0,0,1-29.47.93c-13.91-.73-25.31-4.27-33-9.91s-11.72-13.34-12.37-19.39c-.62-5.68,1.25-12.39,4.38-17.29s7.7-8.63,14.25-12.68,15.44-9,25.57-15.12,21.78-13.52,34.06-20.9Z"
  })), _path162 || (_path162 = /*#__PURE__*/React.createElement("path", {
    className: "cls-162",
    d: "M1460.78,255.33c10.07-6.1,19.75-10.85,28.58-13.74s16.8-3.92,23.8-3.19c11.5,1.2,19.88,7.59,25.3,16.71,4,6.67,7.16,14.18,10.65,20.28,4.14,7.24,7.25,12.72,8,18.06s-.9,10.61-5.23,16.31A65.86,65.86,0,0,1,1540,321.53a133.14,133.14,0,0,1-18.74,12.06c-8.22,4.45-18.8,8-29.76,10.62a255.81,255.81,0,0,1-33,5.49,239.82,239.82,0,0,1-30.08,1.36c-14.13-.36-25.86-3.45-33.84-8.75s-12.23-12.79-13-18.71c-.75-5.6,1.08-12.32,4.25-17.38s7.85-9,14.57-13.29,15.72-9.61,26-16S1448.35,262.86,1460.78,255.33Z"
  })), _path163 || (_path163 = /*#__PURE__*/React.createElement("path", {
    className: "cls-163",
    d: "M1463.14,255c10.16-6.19,19.92-11.06,28.78-14s16.84-4.08,23.79-3.36c11.55,1.21,19.85,7.82,25.21,17.07,3.9,6.74,7,14.29,10.47,20.44,4.09,7.3,7.37,12.75,8.38,18s-.28,10.39-4.3,16A60.48,60.48,0,0,1,1544,320.73a131.69,131.69,0,0,1-18.6,12.14c-8.2,4.51-18.86,8.11-30,10.8a264.47,264.47,0,0,1-33.54,5.67,274.27,274.27,0,0,1-30.72,1.74c-14.35-.07-26.39-2.63-34.66-7.59s-12.75-12.23-13.67-18c-.88-5.51.88-12.22,4.11-17.45s8-9.33,14.89-13.91c4.64-3.09,10.25-6.59,16.5-10.59q10.41-6.65,20.78-13.34c7.55-4.86,15.67-10.09,24-15.2Z"
  })), _path164 || (_path164 = /*#__PURE__*/React.createElement("path", {
    className: "cls-164",
    d: "M1465.5,254.61c10.25-6.28,20.07-11.25,29-14.32s16.87-4.21,23.78-3.48c11.59,1.21,19.8,8.07,25.11,17.46,3.84,6.79,6.88,14.38,10.29,20.57,4,7.36,7.49,12.77,8.76,17.94s.34,10.16-3.37,15.64A55.27,55.27,0,0,1,1548,320a131,131,0,0,1-18.45,12.21c-8.19,4.56-18.92,8.22-30.12,11a275.7,275.7,0,0,1-34,5.83,312.88,312.88,0,0,1-31.34,2.08c-14.63.18-26.94-1.85-35.49-6.47s-13.27-11.65-14.33-17.3c-1-5.43.68-12.11,4-17.5s8.16-9.7,15.23-14.55c4.74-3.27,10.42-7,16.75-11.2s13.4-8.85,21-13.86S1457,259.8,1465.5,254.61Z"
  })), _path165 || (_path165 = /*#__PURE__*/React.createElement("path", {
    className: "cls-165",
    d: "M1467.87,254.21c10.33-6.35,20.22-11.42,29.15-14.55s16.89-4.32,23.76-3.58c11.63,1.25,19.75,8.35,25,17.89,3.79,6.86,6.73,14.48,10.1,20.7,8,14.82,13.52,22.43,6.72,33.15a50.29,50.29,0,0,1-10.6,11.43,128.4,128.4,0,0,1-18.3,12.26c-8.16,4.63-19,8.34-30.27,11.11a283.6,283.6,0,0,1-34.49,6c-11.32,1.31-22.15,2.11-32,2.37-14.91.41-27.49-1.11-36.33-5.38s-13.81-11.06-15-16.57c-1.16-5.34.47-12,3.81-17.52s8.32-10.07,15.57-15.21q8.43-6,17-11.8c6.41-4.36,13.57-9.2,21.3-14.36s16-10.64,24.59-15.91Z"
  })), _path166 || (_path166 = /*#__PURE__*/React.createElement("path", {
    className: "cls-166",
    d: "M1470.57,253.39c10.42-6.43,20.37-11.59,29.33-14.77s16.91-4.39,23.72-3.61c11.66,1.32,19.66,8.74,24.85,18.47,3.71,7,6.52,14.63,9.81,20.89,7.86,15,14.14,22.26,8,32.74a45.47,45.47,0,0,1-10.14,11.29,126,126,0,0,1-18.07,12.31c-8.13,4.67-19,8.44-30.39,11.26a294.11,294.11,0,0,1-35,6.11c-11.52,1.38-22.58,2.28-32.63,2.7-15.2.64-28.09-.34-37.22-4.25s-14.34-10.47-15.66-15.86.29-11.89,3.69-17.63,8.57-10.31,16-16c5-3.82,10.72-7.91,17.22-12.47s13.75-9.6,21.58-14.92S1461.93,258.72,1470.57,253.39Z"
  })), _path167 || (_path167 = /*#__PURE__*/React.createElement("path", {
    className: "cls-167",
    d: "M1472.83,253.1c10.49-6.48,20.49-11.7,29.48-14.93s16.93-4.45,23.69-3.66c11.69,1.38,19.6,9.08,24.76,18.94,3.66,7,6.39,14.7,9.66,21,7.8,15,14.86,22,9.35,32.25-1.88,3.49-5.07,7.21-9.68,11.16a125.36,125.36,0,0,1-17.9,12.34c-8.1,4.72-19,8.52-30.51,11.36a300.7,300.7,0,0,1-35.37,6.17c-11.7,1.4-23,2.36-33.21,2.89-15.47.81-28.65.29-38.07-3.26s-14.89-9.85-16.36-15.09,0-11.68,3.5-17.58,8.81-10.75,16.32-16.69c5-4,10.83-8.24,17.4-13s13.91-9.91,21.82-15.36,16.39-11.17,25.12-16.55Z"
  })), _path168 || (_path168 = /*#__PURE__*/React.createElement("path", {
    className: "cls-168",
    d: "M1475.07,252.8c10.57-6.51,20.63-11.8,29.63-15.06s16.94-4.5,23.65-3.67c11.74,1.45,19.56,9.43,24.67,19.44,3.61,7.06,6.28,14.75,9.51,21,7.73,15,15.59,21.76,10.7,31.76-1.67,3.42-4.71,7.08-9.21,11a122,122,0,0,1-17.72,12.37c-8.07,4.76-19,8.6-30.63,11.46a300.83,300.83,0,0,1-35.77,6.19q-16.83,2-33.75,3c-15.74,1-29.23.88-38.94-2.32s-15.44-9.22-17-14.3-.21-11.44,3.3-17.51,9-11.21,16.62-17.39c5.07-4.13,10.94-8.55,17.59-13.43q10.92-8,22-15.79c8-5.58,16.56-11.38,25.36-16.81Z"
  })), _path169 || (_path169 = /*#__PURE__*/React.createElement("path", {
    className: "cls-169",
    d: "M1564.62,274.71c6.48,12.65,13.84,19,13.22,26.79s-9.73,17.09-27.43,27.69c-8,4.81-19,8.68-30.7,11.54a302.79,302.79,0,0,1-36.14,6.18c-12,1.43-23.67,2.44-34.33,3.16-16,1.09-29.78,1.42-39.79-1.42s-16-8.58-17.76-13.51-.48-11.19,3.09-17.41,9.26-11.67,16.92-18.09c5.11-4.28,11-8.87,17.76-13.9q11-8.26,22.27-16.21c8.07-5.69,16.72-11.58,25.59-17,17.75-10.91,33.88-18.15,46.36-19s21.34,4.62,27.41,13.13S1560.3,266.27,1564.62,274.71Z"
  })), _path170 || (_path170 = /*#__PURE__*/React.createElement("path", {
    className: "cls-170",
    d: "M1471.37,259.62c13.45-8.11,26.15-14.5,37-17.53s19.85-2.7,26.91.56c6.79,3.14,11.83,8.87,15.64,15.48s7.4,13.55,11.15,19.42c6.58,10.3,13.36,16.45,14.34,23.17.54,3.72-.67,7.57-4.1,11.84-4.72,5.9-13.9,12.68-26.45,19.79-8.78,5-20.43,8.86-32.52,11.54a280.07,280.07,0,0,1-36.7,5.25q-16.94,1.41-33.94,1.83c-14.64.37-27.38-.14-36.69-3.22s-15-8.48-16.92-12.83-1.33-9.42,2-15.28,8.49-10.48,15.94-16.23,16.76-12.21,27.68-19.73,23.48-16.1,36.67-24.06Z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "cls-171"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-172",
    points: "1003.41 119 1114.22 119 1018.46 -53.04 1171 -221 1060.19 -221 976.73 -129.2 925.43 -221 814.62 -221 907.64 -53.04 751 119 861.81 119 950.05 22.44 1003.41 119"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAmiriyaHero);
export default __webpack_public_path__ + "static/media/amiriyaHero.120d8ff076a2f093779c3d294d02c44b.svg";
export { ForwardRef as ReactComponent };